import { DatePipe } from "@angular/common";
import { jsPDF } from "jspdf";
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { EmailItineraryProperties } from "../Models/ERPProperties";
import { AirSegmentsDetailsNew, FaretypeFilters, FilterByAirlineProperties, FilterFlightResultBinding, FlightSchedulesNew, FlightSearchNewResponseProperties, MulticityResponseFlightsNew, StopFlightFilters } from "../Models/flight-results-response-properties";
import { FlightSearchProperties } from "../Models/FlightSearchProperties";
import { ChangeRBDParamsGalileo, PassengerFares, SelectRBD } from "../Models/FlightSearchResponseProperties";
import { fontEnvironment } from '../../environments/fontEnvironment';
import { Canvg } from 'canvg';
import autoTable from 'jspdf-autotable';
export class FlightResultAdditionalProcess {


  MainStopFilter: FlightSchedulesNew[] = [];
  MainStopFilterR: FlightSchedulesNew[] = [];
  MainRefundFilter: FlightSchedulesNew[] = [];
  CombineFilters: FlightSchedulesNew[] = [];

  RefundableFlights: FlightSchedulesNew[] = [];

  NonRefundableFlights: FlightSchedulesNew[] = [];

  morningFlights: FlightSchedulesNew[] = [];
  afternoonFlights: FlightSchedulesNew[] = [];
  nightFlights: FlightSchedulesNew[] = [];
  midnightFlights: FlightSchedulesNew[] = [];
  mainTimingFilter: FlightSchedulesNew[] = [];

  flightNamesForFilter: string[] = [];
  mainairlinesFilter: FlightSchedulesNew[] = [];
  flightsBindList: FlightSchedulesNew[] = [];
  flightDataCarry: FlightSchedulesNew[] = [];
  FlightPriceFilter(changeContext, flighResultObj: FlightSearchNewResponseProperties, modifysearchObj: FlightSearchProperties): any {
    let lowerHandlePrice = changeContext.start;
    let higherHandlePrice = changeContext.end;
    let flights: FlightSchedulesNew[] = [];
    let flightsFiltered: FlightSchedulesNew[] = [];
    flights = flighResultObj.flights;
    flightsFiltered = [];
    if (modifysearchObj.tripType == "multi" && flights != undefined) {
      this.flightsBindList = flights.filter(mulFly => Number(mulFly.multiFlights[0].agencyTotalPrice.slice(3)) >= lowerHandlePrice
        && Number(mulFly.multiFlights[0].agencyTotalPrice.slice(3)) <= higherHandlePrice)
    }
    else if (modifysearchObj.tripType != "multi" && flights != undefined){
      flightsFiltered = flights.filter(flight => Number(flight.departureFlight.agencyTotalPrice.slice(3)) >= lowerHandlePrice && Number(flight.departureFlight.agencyTotalPrice.slice(3)) <= higherHandlePrice);
      this.flightsBindList = flightsFiltered;
    }
    return this.flightsBindList;
  }
  NonStopFlights: FlightSchedulesNew[] = [];
  oneStopFlights: FlightSchedulesNew[] = [];
  twoStopFlights: FlightSchedulesNew[] = [];
  RNonStopFlights: FlightSchedulesNew[] = [];
  RoneStopFlights: FlightSchedulesNew[] = [];
  RtwoStopFlights: FlightSchedulesNew[] = [];

  CombineFilter(event: any, value: string, multiflight: boolean, flightScheduleData: FlightSchedulesNew[], filterobj: FilterFlightResultBinding, searchObj: FlightSearchProperties, flighResultObj: FlightSearchNewResponseProperties): any {
    let NonStopFlights: FlightSchedulesNew[] = [];
    let oneStopFlights: FlightSchedulesNew[] = [];
    let twoStopFlights: FlightSchedulesNew[] = [];
    let RNonStopFlights: FlightSchedulesNew[] = [];
    let RoneStopFlights: FlightSchedulesNew[] = [];
    let RtwoStopFlights: FlightSchedulesNew[] = [];

    //////////////////////////////Multi Start////////////////////////////

    if (multiflight) {
      if (
        event.target.value == 'nonStop' ||
        event.target.value == 'oneStop' ||
        event.target.value == 'twoStop'
      ) {
        if (event.target.value == 'nonStop') {
          NonStopFlights = flightScheduleData;
          if (filterobj.stopsDetails.directchecked == true) {
            var nonStoplist = NonStopFlights.filter(
              (z) => z.multiFlights[0].stopCount == 0
            );
            this.NonStopFlights = this.NonStopFlights.concat(nonStoplist);

            /////
            if (
              filterobj.stopsDetails.directchecked == true ||
              filterobj.stopsDetails.onestopchecked == true ||
              filterobj.stopsDetails.twoplusstopchecked == true
            ) {
              this.MainStopFilter = this.oneStopFlights
                .concat(this.twoStopFlights)
                .concat(this.NonStopFlights);
              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilterMulti(
                this.MainStopFilter,
                internalRefFlights, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.MainStopFilter = internalRefFlights;
              }
              let internalDayTFlights: FlightSchedulesNew[] = [];
              internalDayTFlights = this.internalDaysTimeFilterMulti(
                this.MainStopFilter,
                internalDayTFlights, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainStopFilter = internalDayTFlights;
              }
              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainStopFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainStopFilter = internalAirFlights;
              }

              let sdup: FlightSchedulesNew[] = [];
              sdup = this.MainStopFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }

            //////
          } else if (filterobj.stopsDetails.directchecked == false) {
            var nonStoplist = NonStopFlights.filter(
              (z) => z.multiFlights[0].stopCount == 0
            );
            nonStoplist.forEach((ele, index) => {
              this.NonStopFlights.forEach((item, idx) => {
                if (
                  item.multiFlights[0].stopCount == 0 &&
                  ele.multiFlights[0].stopCount == 0
                ) {
                  this.NonStopFlights.splice(idx, 1);
                }
              });
            });

            /////////
            if (
              filterobj.stopsDetails.directchecked == false ||
              filterobj.stopsDetails.onestopchecked == false ||
              filterobj.stopsDetails.twoplusstopchecked == false
            ) {
              this.MainStopFilter = this.oneStopFlights
                .concat(this.twoStopFlights)
                .concat(this.NonStopFlights);

              if (
                filterobj.stopsDetails.directchecked == false &&
                filterobj.stopsDetails.onestopchecked == false &&
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                if (this.MainStopFilter.length == 0) {
                  if (filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.nightChecked == true ||
                    filterobj.timeList.eveningChecked == true
                    || filterobj.timeList.afternoonChecked == true) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.fareType.refundableFlightschecked == true ||
                    filterobj.fareType.nonRefundableFlightschecked == true
                  ) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.MainStopFilter.length == 0) {
                this.MainStopFilter = flightScheduleData;
              }

              if (
                filterobj.stopsDetails.directchecked != false ||
                filterobj.stopsDetails.onestopchecked != false ||
                filterobj.stopsDetails.twoplusstopchecked != false
              ) {
                let internalStopFlights: FlightSchedulesNew[] = [];
                internalStopFlights = this.internalStopFilterMulti(this.MainStopFilter, internalStopFlights, filterobj);
                this.MainStopFilter = internalStopFlights;
              }
              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilterMulti(
                this.MainStopFilter,
                internalRefFlights, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.MainStopFilter = internalRefFlights;
              }
              let internalDayTFlights: FlightSchedulesNew[] = [];
              internalDayTFlights = this.internalDaysTimeFilterMulti(
                this.MainStopFilter,
                internalDayTFlights, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainStopFilter = internalDayTFlights;
              }
              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainStopFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainStopFilter = internalAirFlights;
              }

              let sdup: FlightSchedulesNew[] = [];
              sdup = this.MainStopFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }
          }
          //////
        }
        //one stop
        if (event.target.value == 'oneStop') {
          oneStopFlights = flightScheduleData;
          if (filterobj.stopsDetails.onestopchecked == true) {
            var oneStopList = oneStopFlights.filter(
              (x) => x.multiFlights[0].stopCount == 1
            );
            this.oneStopFlights = this.oneStopFlights.concat(oneStopList);

            ////
            if (
              filterobj.stopsDetails.directchecked == true ||
              filterobj.stopsDetails.onestopchecked == true ||
              filterobj.stopsDetails.twoplusstopchecked == true
            ) {
              this.MainStopFilter = this.oneStopFlights
                .concat(this.twoStopFlights)
                .concat(this.NonStopFlights);
              //

              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilterMulti(
                this.MainStopFilter,
                internalRefFlights, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.MainStopFilter = internalRefFlights;
              }
              let internalDayTFlights: FlightSchedulesNew[] = [];
              internalDayTFlights = this.internalDaysTimeFilterMulti(
                this.MainStopFilter,
                internalDayTFlights, filterobj
              )!;

              let sdup: FlightSchedulesNew[] = [];
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainStopFilter = internalDayTFlights;
              }
              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainStopFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainStopFilter = internalAirFlights;
              }
              sdup = this.MainStopFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }
            ////
          } else if (filterobj.stopsDetails.onestopchecked == false) {
            var oneStopList = oneStopFlights.filter(
              (x) => x.multiFlights[0].stopCount == 1
            );
            oneStopList.forEach((item, index) => {
              this.oneStopFlights.forEach((ele, idx) => {
                if (
                  ele.multiFlights[0].stopCount == 1 &&
                  item.multiFlights[0].stopCount == 1
                ) {
                  this.oneStopFlights.splice(idx, 1);
                }
              });
            });
            /////
            if (
              filterobj.stopsDetails.directchecked == false ||
              filterobj.stopsDetails.onestopchecked == false ||
              filterobj.stopsDetails.twoplusstopchecked == false
            ) {
              this.MainStopFilter = this.oneStopFlights
                .concat(this.twoStopFlights)
                .concat(this.NonStopFlights);

              if (
                filterobj.stopsDetails.directchecked == false &&
                filterobj.stopsDetails.onestopchecked == false &&
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                if (this.MainStopFilter.length == 0) {
                  if (
                    filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.afternoonChecked == true ||
                    filterobj.timeList.eveningChecked == true ||
                    filterobj.timeList.nightChecked == true
                  ) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.fareType.refundableFlightschecked == true ||
                    filterobj.fareType.nonRefundableFlightschecked == true
                  ) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.MainStopFilter.length == 0) {
                this.MainStopFilter = flightScheduleData;
              }

              if (
                filterobj.stopsDetails.directchecked != false ||
                filterobj.stopsDetails.onestopchecked != false ||
                filterobj.stopsDetails.twoplusstopchecked != false
              ) {
                let internalStopFlights: FlightSchedulesNew[] = [];
                internalStopFlights = this.internalStopFilterMulti(
                  this.MainStopFilter,
                  internalStopFlights, filterobj
                )!;
                this.MainStopFilter = internalStopFlights;
              }

              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilterMulti(
                this.MainStopFilter,
                internalRefFlights, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.MainStopFilter = internalRefFlights;
              }
              let internalDayTFlights: FlightSchedulesNew[] = [];
              internalDayTFlights = this.internalDaysTimeFilterMulti(
                this.MainStopFilter,
                internalDayTFlights, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainStopFilter = internalDayTFlights;
              }
              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainStopFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainStopFilter = internalAirFlights;
              }

              let sdup: FlightSchedulesNew[] = [];
              sdup = this.MainStopFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            ////
          }
        }
        //two stop
        if (event.target.value == 'twoStop') {
          twoStopFlights = flightScheduleData;
          if (filterobj.stopsDetails.twoplusstopchecked == true) {
            var twoStopList = twoStopFlights.filter(
              (y) => y.multiFlights[0].stopCount >= 2
            ); //
            this.twoStopFlights = this.twoStopFlights.concat(twoStopList);

            ////
            if (
              filterobj.stopsDetails.directchecked == true ||
              filterobj.stopsDetails.onestopchecked == true ||
              filterobj.stopsDetails.twoplusstopchecked == true
            ) {
              this.MainStopFilter = this.oneStopFlights
                .concat(this.twoStopFlights)
                .concat(this.NonStopFlights);
              //
              let sdup: FlightSchedulesNew[] = [];
              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilterMulti(
                this.MainStopFilter,
                internalRefFlights, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.MainStopFilter = internalRefFlights;
              }
              let internalDayTFlights: FlightSchedulesNew[] = [];
              internalDayTFlights = this.internalDaysTimeFilterMulti(
                this.MainStopFilter,
                internalDayTFlights, filterobj
              )!;

              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainStopFilter = internalDayTFlights;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainStopFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainStopFilter = internalAirFlights;
              }

              sdup = this.MainStopFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }
            ////
          } else if (filterobj.stopsDetails.twoplusstopchecked == false) {
            var twoStopList = twoStopFlights.filter(
              (y) => y.multiFlights[0].stopCount >= 2
            );
            twoStopList.forEach((item, index) => {
              this.twoStopFlights.forEach((ele, idx) => {
                if (
                  ele.multiFlights[0].stopCount >= 2 &&
                  item.multiFlights[0].stopCount >= 2
                ) {
                  this.twoStopFlights.splice(idx, 1);
                }
              });
            });

            /////
            if (
              filterobj.stopsDetails.directchecked == false ||
              filterobj.stopsDetails.onestopchecked == false ||
              filterobj.stopsDetails.twoplusstopchecked == false
            ) {
              this.MainStopFilter = this.oneStopFlights
                .concat(this.twoStopFlights)
                .concat(this.NonStopFlights);

              if (
                filterobj.stopsDetails.directchecked == false &&
                filterobj.stopsDetails.onestopchecked == false &&
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                if (this.MainStopFilter.length == 0) {
                  if (
                    filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.afternoonChecked == true ||
                    filterobj.timeList.eveningChecked == true ||
                    filterobj.timeList.nightChecked == true
                  ) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.fareType.refundableFlightschecked == true ||
                    filterobj.fareType.nonRefundableFlightschecked == true
                  ) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainStopFilter = this.MainStopFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.MainStopFilter.length == 0) {
                this.MainStopFilter = flightScheduleData;
              }

              if (
                filterobj.stopsDetails.directchecked != false ||
                filterobj.stopsDetails.onestopchecked != false ||
                filterobj.stopsDetails.twoplusstopchecked != false
              ) {
                let internalStopFlights: FlightSchedulesNew[] = [];
                internalStopFlights = this.internalStopFilterMulti(
                  this.MainStopFilter,
                  internalStopFlights, filterobj
                )!;
                this.MainStopFilter = internalStopFlights;
              }

              let sdup: FlightSchedulesNew[] = [];
              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilterMulti(
                this.MainStopFilter,
                internalRefFlights, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.MainStopFilter = internalRefFlights;
              }
              let internalDayTFlights: FlightSchedulesNew[] = [];
              internalDayTFlights = this.internalDaysTimeFilterMulti(
                this.MainStopFilter,
                internalDayTFlights, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainStopFilter = internalDayTFlights;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainStopFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainStopFilter = internalAirFlights;
              }

              sdup = this.MainStopFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }
            ////
          }
        }
      }

      /////////////////////////////////////////////////Stop Filter End///////
      /////////////////////////////////////////////////Refundable Filter///////

      let RefundableFlights: FlightSchedulesNew[];
      let NonRefundableFlights: FlightSchedulesNew[];
      if (
        event.target.value == 'refundable' ||
        event.target.value == 'nonRefundable'
      ) {
        if (event.target.value == 'refundable') {
          RefundableFlights = flightScheduleData;

          if (filterobj.fareType.refundableFlightschecked == true) {
            var refundList = RefundableFlights.filter(
              (x) => x.multiFlights[0].nonRefundable == false
            );
            this.RefundableFlights = this.RefundableFlights.concat(refundList);
            ////
            if (
              filterobj.fareType.refundableFlightschecked == true ||
              filterobj.fareType.nonRefundableFlightschecked == true
            ) {
              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );
              let dup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.MainRefundFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }

              dup = this.MainRefundFilter;
              this.flightDataCarry = [...new Set(dup)];
            }
            ////
          } else if (filterobj.fareType.refundableFlightschecked == false) {
            var refundList = RefundableFlights.filter(
              (x) => x.multiFlights[0].nonRefundable == false
            );
            refundList.forEach((ele, index) => {
              this.RefundableFlights.forEach((item, idx) => {
                if (
                  item.multiFlights[0].nonRefundable ==
                  ele.multiFlights[0].nonRefundable &&
                  item.multiFlights[0].airlineLegalName ==
                  ele.multiFlights[0].airlineLegalName &&
                  item.multiFlights[0].departure.time ==
                  ele.multiFlights[0].departure.time
                )
                  this.RefundableFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.fareType.nonRefundableFlightschecked == false ||
              filterobj.fareType.refundableFlightschecked == false
            ) {
              let dup: FlightSchedulesNew[] = [];
              // let innerFilter = false;
              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );

              if (
                filterobj.fareType.nonRefundableFlightschecked == false &&
                filterobj.fareType.refundableFlightschecked == false
              ) {
                if (this.MainRefundFilter.length == 0) {
                  if (
                    filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.afternoonChecked == true ||
                    filterobj.timeList.eveningChecked == true ||
                    filterobj.timeList.nightChecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.MainRefundFilter.length == 0) {
                this.MainRefundFilter = flightScheduleData;
              }

              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.MainRefundFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }

              dup = this.MainRefundFilter;
              this.flightDataCarry = [...new Set(dup)];
              dup = this.MainRefundFilter;
            }
            //////
          }
        }

        if (event.target.value == 'nonRefundable') {
          NonRefundableFlights = flightScheduleData;

          if (filterobj.fareType.nonRefundableFlightschecked == true) {
            var nonRefundList = NonRefundableFlights.filter(
              (x) => x.multiFlights[0].nonRefundable == true
            );

            this.NonRefundableFlights =
              this.NonRefundableFlights.concat(nonRefundList);
            ////
            if (
              filterobj.fareType.refundableFlightschecked == true ||
              filterobj.fareType.nonRefundableFlightschecked == true
            ) {
              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );
              let dup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.MainRefundFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }

              dup = this.MainRefundFilter;

              this.flightDataCarry = [...new Set(dup)];
            }
            ////
          } else if (filterobj.fareType.nonRefundableFlightschecked == false) {
            var nonRefundList = NonRefundableFlights.filter(
              (x) => x.multiFlights[0].nonRefundable == true
            );
            nonRefundList.forEach((ele, index) => {
              this.NonRefundableFlights.forEach((item, idx) => {
                if (
                  item.multiFlights[0].nonRefundable ==
                  ele.multiFlights[0].nonRefundable &&
                  item.multiFlights[0].airlineLegalName ==
                  ele.multiFlights[0].airlineLegalName &&
                  item.multiFlights[0].departure.time ==
                  ele.multiFlights[0].departure.time
                )
                  this.NonRefundableFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.fareType.nonRefundableFlightschecked == false ||
              filterobj.fareType.refundableFlightschecked == false
            ) {
              let dup: FlightSchedulesNew[] = [];

              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );

              if (
                filterobj.fareType.nonRefundableFlightschecked == false &&
                filterobj.fareType.refundableFlightschecked == false
              ) {
                if (this.MainRefundFilter.length == 0) {
                  if (
                    filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.afternoonChecked == true ||
                    filterobj.timeList.eveningChecked == true ||
                    filterobj.timeList.nightChecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.MainRefundFilter.length == 0) {
                this.MainRefundFilter = flightScheduleData;
              }
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.MainRefundFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }

              dup = this.MainRefundFilter;
              this.flightDataCarry = [...new Set(dup)];
            }
            //////
          }
        }
      }

      /////////////////////////////////////////////////Refundable Filter End///////
      /////////////////////////////////////////////////Timing Filter Start///////
      let morninglo: FlightSchedulesNew[];
      let afternoonlo: FlightSchedulesNew[];
      let nightlo: FlightSchedulesNew[];
      let midnightlo: FlightSchedulesNew[];
      if (
        event.target.value == 'Morning' ||
        event.target.value == 'Afternoon' ||
        event.target.value == 'Night' ||
        event.target.value == 'Midnight'
      ) {
        if (event.target.value == 'Morning') {
          morninglo = flightScheduleData;
          if (filterobj.timeList.morningChecked == true) {
            var morninglist = morninglo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '05:00' &&
                z.multiFlights[0].departure.time <= '11:59'
            );
            this.morningFlights = this.morningFlights.concat(morninglist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];

              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.morningChecked == false) {
            var morninglist = morninglo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '05:00' &&
                z.multiFlights[0].departure.time <= '11:59'
            );
            morninglist.forEach((item, index, array) => {
              this.morningFlights.forEach((im, idx, ar) => {
                if (
                  item.multiFlights[0].departure.time ==
                  im.multiFlights[0].departure.time &&
                  item.multiFlights[0].airlineLegalName ==
                  im.multiFlights[0].airlineLegalName
                )
                  this.morningFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }
              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];
              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }

              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }
              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
        //Afternoon
        if (event.target.value == 'Afternoon') {
          afternoonlo = flightScheduleData;
          if (filterobj.timeList.afternoonChecked == true) {
            var afternoonlist = afternoonlo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '12:00' &&
                z.multiFlights[0].departure.time <= '17:59'
            );
            this.afternoonFlights = this.afternoonFlights.concat(afternoonlist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }
              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.afternoonChecked == false) {
            var afternoonlist = afternoonlo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '12:00' &&
                z.multiFlights[0].departure.time <= '17:59'
            );
            afternoonlist.forEach((item, index, array) => {
              this.afternoonFlights.forEach((im, idx, ar) => {
                if (
                  item.multiFlights[0].departure.time ==
                  im.multiFlights[0].departure.time &&
                  item.multiFlights[0].airlineLegalName ==
                  im.multiFlights[0].airlineLegalName
                )
                  this.afternoonFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }
              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }


              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
        //night
        if (event.target.value == 'Night') {
          nightlo = flightScheduleData;
          if (filterobj.timeList.eveningChecked == true) {
            var nightlist = nightlo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '18:00' &&
                z.multiFlights[0].departure.time <= '23:59'
            );
            this.nightFlights = this.nightFlights.concat(nightlist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.eveningChecked == false) {
            var nightlist = nightlo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '18:00' &&
                z.multiFlights[0].departure.time <= '23:59'
            );
            nightlist.forEach((item, index, array) => {
              this.nightFlights.forEach((im, idx, ar) => {
                if (
                  item.multiFlights[0].departure.time ==
                  im.multiFlights[0].departure.time &&
                  item.multiFlights[0].airlineLegalName ==
                  im.multiFlights[0].airlineLegalName
                )
                  this.nightFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);
              //

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }

              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }


              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
        //midnight
        if (event.target.value == 'Midnight') {
          midnightlo = flightScheduleData;
          if (filterobj.timeList.nightChecked == true) {
            var midnightlist = midnightlo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '00:00' &&
                z.multiFlights[0].departure.time <= '04:59'
            );
            this.midnightFlights = this.midnightFlights.concat(midnightlist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.nightChecked == false) {
            var midnightlist = midnightlo.filter(
              (z) =>
                z.multiFlights[0].departure.time >= '00:00' &&
                z.multiFlights[0].departure.time <= '04:59'
            );
            midnightlist.forEach((item, index, array) => {
              this.midnightFlights.forEach((im, idx, ar) => {
                if (
                  item.multiFlights[0].departure.time ==
                  im.multiFlights[0].departure.time &&
                  item.multiFlights[0].airlineLegalName ==
                  im.multiFlights[0].airlineLegalName
                )
                  this.midnightFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);
              //

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }

              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];
              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              internalStopF = this.internalStopFilterMulti(
                this.mainTimingFilter,
                internalStopF, filterobj
              )!;
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilterMulti(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }


              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilterMulti(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.morningChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }


              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilterMulti(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }


              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
      }

      /////////////////////////////////////////////////Timing Filter End///////
      /////////////////////////////////////////////////Airline Filter Start///////

      let airlineslo: FlightSchedulesNew[];
      let useInFilters: FlightSchedulesNew[] = [];
      if (event.target.checked == true && value == 'airlines') {
        airlineslo = flightScheduleData;
        this.flightNamesForFilter.push(event.target.value);
        if (this.flightNamesForFilter.length > 0) {
          this.mainairlinesFilter = [];
          for (let a = 0; a < this.flightNamesForFilter.length; a++) {
            var airlineList = airlineslo.filter(
              (x) =>
                x.multiFlights[0].airlineLegalName ==
                this.flightNamesForFilter[a]
            );
            this.mainairlinesFilter =
              this.mainairlinesFilter.concat(airlineList);
          }
        }
        ////

        let sdup: FlightSchedulesNew[] = [];
        let internalStopF: FlightSchedulesNew[] = [];

        internalStopF = this.internalStopFilterMulti(
          this.mainairlinesFilter,
          internalStopF, filterobj
        )!;
        if (
          filterobj.stopsDetails.directchecked == true ||
          filterobj.stopsDetails.onestopchecked == true ||
          filterobj.stopsDetails.twoplusstopchecked == true
        ) {
          this.mainairlinesFilter = internalStopF;
        }
        let internlRefundTimeF: FlightSchedulesNew[] = [];
        internlRefundTimeF = this.internalRefundFilterMulti(
          this.mainairlinesFilter,
          internlRefundTimeF, filterobj
        )!;
        if (
          filterobj.fareType.refundableFlightschecked == true ||
          filterobj.fareType.nonRefundableFlightschecked == true
        ) {
          this.mainairlinesFilter = internlRefundTimeF;
        }
        let internaldayTimeF: FlightSchedulesNew[] = [];
        internaldayTimeF = this.internalDaysTimeFilterMulti(
          this.mainairlinesFilter,
          internaldayTimeF, filterobj
        )!;
        if (
          filterobj.timeList.morningChecked == true ||
          filterobj.timeList.afternoonChecked == true ||
          filterobj.timeList.eveningChecked == true ||
          filterobj.timeList.nightChecked == true
        ) {
          this.mainairlinesFilter = internaldayTimeF;
        }


        sdup = this.mainairlinesFilter;

        this.flightDataCarry = [...new Set(sdup)];
      } else if (event.target.checked == false && value == 'airlines') {
        airlineslo = flightScheduleData;

        if (this.flightNamesForFilter.length > 0) {
          this.mainairlinesFilter = [];
          for (let a = 0; a < this.flightNamesForFilter.length; a++) {
            var airlineList = airlineslo.filter(
              (x) =>
                x.multiFlights[0].airlineLegalName ==
                this.flightNamesForFilter[a]
            );
            this.mainairlinesFilter =
              this.mainairlinesFilter.concat(airlineList);
          }
        }

        const name = event.target.value;
        var airlineList = airlineslo.filter(
          (x) => x.multiFlights[0].airlineLegalName == name
        );
        airlineList.forEach((ele, index) => {
          this.mainairlinesFilter.forEach((item, idx) => {
            if (
              item.multiFlights[0].airlineLegalName == name &&
              ele.multiFlights[0].airlineLegalName == name
            ) {
              this.mainairlinesFilter.splice(idx, 1);
            }
          });
        });

        let deletingAirlineIndex = this.flightNamesForFilter.findIndex(
          (ele) => ele == event.target.value
        );
        this.flightNamesForFilter.splice(deletingAirlineIndex, 1);
        ////

        if (this.mainairlinesFilter.length == 0) {
          if (
            filterobj.timeList.morningChecked == false &&
            filterobj.timeList.afternoonChecked == false &&
            filterobj.timeList.eveningChecked == false &&
            filterobj.timeList.nightChecked == false
          ) {
            this.mainairlinesFilter = this.mainairlinesFilter.concat(
              this.mainTimingFilter
            );
          }

          if (
            filterobj.fareType.nonRefundableFlightschecked == true ||
            filterobj.fareType.refundableFlightschecked == true
          ) {
            this.mainairlinesFilter = this.mainairlinesFilter.concat(
              this.MainRefundFilter
            );
          }
          if (
            filterobj.stopsDetails.directchecked == true ||
            filterobj.stopsDetails.onestopchecked == true ||
            filterobj.stopsDetails.twoplusstopchecked == true
          ) {
            this.mainairlinesFilter = this.mainairlinesFilter.concat(
              this.MainStopFilter
            );
          }
        }

        if (this.mainairlinesFilter.length == 0) {
          this.mainairlinesFilter = flightScheduleData;
        }

        let sdup: FlightSchedulesNew[] = [];
        let internalStopF: FlightSchedulesNew[] = [];

        internalStopF = this.internalStopFilterMulti(
          this.mainairlinesFilter,
          internalStopF, filterobj
        )!;
        if (
          filterobj.stopsDetails.directchecked == true ||
          filterobj.stopsDetails.onestopchecked == true ||
          filterobj.stopsDetails.twoplusstopchecked == true
        ) {
          this.mainairlinesFilter = internalStopF;
        }
        let internlRefundTimeF: FlightSchedulesNew[] = [];
        internlRefundTimeF = this.internalRefundFilterMulti(
          this.mainairlinesFilter,
          internlRefundTimeF, filterobj
        )!;
        if (
          filterobj.fareType.refundableFlightschecked == true ||
          filterobj.fareType.nonRefundableFlightschecked == true
        ) {
          this.mainairlinesFilter = internlRefundTimeF;
        }
        let internaldayTimeF: FlightSchedulesNew[] = [];
        internaldayTimeF = this.internalDaysTimeFilterMulti(
          this.mainairlinesFilter,
          internaldayTimeF, filterobj
        )!;
        if (
          filterobj.timeList.morningChecked == true ||
          filterobj.timeList.afternoonChecked == true ||
          filterobj.timeList.eveningChecked == true ||
          filterobj.timeList.nightChecked == true
        ) {
          this.mainairlinesFilter = internaldayTimeF;
        }

        sdup = this.mainairlinesFilter;

        this.flightDataCarry = [...new Set(sdup)];
      }
      /////////////////////////////////////////////////Airline Filter End///////
    }


    //////////////////////////////Multi End////////////////////////////
    /////////////////////////////One Way Start////////////////////////////
    else {
      if (searchObj.flightLocationInfo.length == 1) {
        if (
          event.target.value == 'nonStop' ||
          event.target.value == 'oneStop' ||
          event.target.value == 'twoStop'
        ) {
          if (event.target.value == 'nonStop') {
            NonStopFlights = flightScheduleData;
            if (filterobj.stopsDetails.directchecked == true) {
              var nonStoplist = NonStopFlights.filter(
                (z) => z.departureFlight.stopCount == 0
              );
              this.NonStopFlights = this.NonStopFlights.concat(nonStoplist);

              /////
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }

                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }

              //////
            } else if (filterobj.stopsDetails.directchecked == false) {
              var nonStoplist = NonStopFlights.filter(
                (z) => z.departureFlight.stopCount == 0
              );
              nonStoplist.forEach((ele, index) => {
                this.NonStopFlights.forEach((item, idx) => {
                  if (
                    item.departureFlight.stopCount == 0 &&
                    ele.departureFlight.stopCount == 0
                  ) {
                    this.NonStopFlights.splice(idx, 1);
                  }
                });
              });

              /////////
              if (
                filterobj.stopsDetails.directchecked == false ||
                filterobj.stopsDetails.onestopchecked == false ||
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainRefundFilter
                      );
                    }
                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilter.length == 0) {
                  this.MainStopFilter = flightScheduleData;
                }

                if (
                  filterobj.stopsDetails.directchecked != false ||
                  filterobj.stopsDetails.onestopchecked != false ||
                  filterobj.stopsDetails.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalStopFilter(
                    this.MainStopFilter,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilter = internalStopFlights;
                }

                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }

                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
            }
            //////
          }
          //one stop
          if (event.target.value == 'oneStop') {
            oneStopFlights = flightScheduleData;
            if (filterobj.stopsDetails.onestopchecked == true) {
              var oneStopList = oneStopFlights.filter(
                (x) => x.departureFlight.stopCount == 1
              );
              this.oneStopFlights = this.oneStopFlights.concat(oneStopList);

              ////
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);
                //
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;

                let sdup: FlightSchedulesNew[] = [];
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }
                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            } else if (filterobj.stopsDetails.onestopchecked == false) {
              var oneStopList = oneStopFlights.filter(
                (x) => x.departureFlight.stopCount == 1
              );
              oneStopList.forEach((item, index) => {
                this.oneStopFlights.forEach((ele, idx) => {
                  if (
                    ele.departureFlight.stopCount == 1 &&
                    item.departureFlight.stopCount == 1
                  ) {
                    this.oneStopFlights.splice(idx, 1);
                  }
                });
              });
              /////
              if (
                filterobj.stopsDetails.directchecked == false ||
                filterobj.stopsDetails.onestopchecked == false ||
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainRefundFilter
                      );
                    }
                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilter.length == 0) {
                  this.MainStopFilter = flightScheduleData;
                }

                if (
                  filterobj.stopsDetails.directchecked != false ||
                  filterobj.stopsDetails.onestopchecked != false ||
                  filterobj.stopsDetails.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalStopFilter(
                    this.MainStopFilter,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilter = internalStopFlights;
                }
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }


                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilter;

                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            }
          }
          //two stop
          if (event.target.value == 'twoStop') {
            twoStopFlights = flightScheduleData;
            if (filterobj.stopsDetails.twoplusstopchecked == true) {
              var twoStopList = twoStopFlights.filter(
                (y) => y.departureFlight.stopCount >= 2
              ); //
              this.twoStopFlights = this.twoStopFlights.concat(twoStopList);

              ////
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);
                //
                let sdup: FlightSchedulesNew[] = [];
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;

                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }

                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }

                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            } else if (filterobj.stopsDetails.twoplusstopchecked == false) {
              var twoStopList = twoStopFlights.filter(
                (y) => y.departureFlight.stopCount >= 2
              );
              twoStopList.forEach((item, index) => {
                this.twoStopFlights.forEach((ele, idx) => {
                  if (
                    ele.departureFlight.stopCount >= 2 &&
                    item.departureFlight.stopCount >= 2
                  ) {
                    this.twoStopFlights.splice(idx, 1);
                  }
                });
              });

              /////
              if (
                filterobj.stopsDetails.directchecked == false ||
                filterobj.stopsDetails.onestopchecked == false ||
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainRefundFilter
                      );
                    }
                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilter.length == 0) {
                  this.MainStopFilter = flightScheduleData;
                }

                if (
                  filterobj.stopsDetails.directchecked != false ||
                  filterobj.stopsDetails.onestopchecked != false ||
                  filterobj.stopsDetails.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalStopFilter(
                    this.MainStopFilter,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilter = internalStopFlights;
                }
                let sdup: FlightSchedulesNew[] = [];
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }

                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }

                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            }
          }
        }
      } else if (searchObj.flightLocationInfo.length == 2) {
        if (
          event.target.value == 'nonStop' ||
          event.target.value == 'oneStop' ||
          event.target.value == 'twoStop'
        ) {
          if (event.target.value == 'nonStop') {
            NonStopFlights = flightScheduleData;
            if (filterobj.stopsDetails.directchecked == true) {
              var nonStoplist = NonStopFlights.filter(
                (z) => z.departureFlight.stopCount == 0
              );
              this.NonStopFlights = this.NonStopFlights.concat(nonStoplist);

              /////
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalReturnStopFilter(
                  this.MainStopFilter,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  this.MainStopFilter = internalStopF;
                }

                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }


                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }

              //////
            } else if (filterobj.stopsDetails.directchecked == false) {
              var nonStoplist = NonStopFlights.filter(
                (z) => z.departureFlight.stopCount == 0
              );
              nonStoplist.forEach((ele, index) => {
                this.NonStopFlights.forEach((item, idx) => {
                  if (
                    item.departureFlight.stopCount == 0 &&
                    ele.departureFlight.stopCount == 0
                  ) {
                    this.NonStopFlights.splice(idx, 1);
                  }
                });
              });

              /////////
              if (
                filterobj.stopsDetails.directchecked == false ||
                filterobj.stopsDetails.onestopchecked == false ||
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    this.MainStopFilter = flightScheduleData;
                  }
                }

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalReturnStopFilter(
                  this.MainStopFilter,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  this.MainStopFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainRefundFilter
                      );
                    }
                    if (
                      filterobj.stopsDetailsReturn.directchecked == true ||
                      filterobj.stopsDetailsReturn.onestopchecked == true ||
                      filterobj.stopsDetailsReturn.twoplusstopchecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainStopFilterR
                      );
                    }

                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilter.length == 0) {
                  this.MainStopFilter = flightScheduleData;
                }

                if (
                  filterobj.stopsDetails.directchecked != false ||
                  filterobj.stopsDetails.onestopchecked != false ||
                  filterobj.stopsDetails.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalStopFilter(
                    this.MainStopFilter,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilter = internalStopFlights;
                }

                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }

                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
            }
            //////
          }
          //one stop
          if (event.target.value == 'oneStop') {
            oneStopFlights = flightScheduleData;
            if (filterobj.stopsDetails.onestopchecked == true) {
              var oneStopList = oneStopFlights.filter(
                (x) => x.departureFlight.stopCount == 1
              );
              this.oneStopFlights = this.oneStopFlights.concat(oneStopList);

              ////
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalReturnStopFilter(
                  this.MainStopFilter,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  this.MainStopFilter = internalStopF;
                }

                //
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;


                let sdup: FlightSchedulesNew[] = [];
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }
                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            } else if (filterobj.stopsDetails.onestopchecked == false) {
              var oneStopList = oneStopFlights.filter(
                (x) => x.departureFlight.stopCount == 1
              );
              oneStopList.forEach((item, index) => {
                this.oneStopFlights.forEach((ele, idx) => {
                  if (
                    ele.departureFlight.stopCount == 1 &&
                    item.departureFlight.stopCount == 1
                  ) {
                    this.oneStopFlights.splice(idx, 1);
                  }
                });
              });
              /////
              if (
                filterobj.stopsDetails.directchecked == false ||
                filterobj.stopsDetails.onestopchecked == false ||
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    this.MainStopFilter = flightScheduleData;
                  }
                }

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalReturnStopFilter(
                  this.MainStopFilter,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  this.MainStopFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainRefundFilter
                      );
                    }

                    if (
                      filterobj.stopsDetailsReturn.directchecked == true ||
                      filterobj.stopsDetailsReturn.onestopchecked == true ||
                      filterobj.stopsDetailsReturn.twoplusstopchecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainStopFilterR
                      );
                    }

                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilter.length == 0) {
                  this.MainStopFilter = flightScheduleData;
                }

                if (
                  filterobj.stopsDetails.directchecked != false ||
                  filterobj.stopsDetails.onestopchecked != false ||
                  filterobj.stopsDetails.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalStopFilter(
                    this.MainStopFilter,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilter = internalStopFlights;
                }
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }

                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilter;

                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            }
          }
          //two stop
          if (event.target.value == 'twoStop') {
            twoStopFlights = flightScheduleData;
            if (filterobj.stopsDetails.twoplusstopchecked == true) {
              var twoStopList = twoStopFlights.filter(
                (y) => y.departureFlight.stopCount >= 2
              ); //
              this.twoStopFlights = this.twoStopFlights.concat(twoStopList);

              ////
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalReturnStopFilter(
                  this.MainStopFilter,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  this.MainStopFilter = internalStopF;
                }
                //
                let sdup: FlightSchedulesNew[] = [];
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;

                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }

                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }


                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            } else if (filterobj.stopsDetails.twoplusstopchecked == false) {
              var twoStopList = twoStopFlights.filter(
                (y) => y.departureFlight.stopCount >= 2
              );
              twoStopList.forEach((item, index) => {
                this.twoStopFlights.forEach((ele, idx) => {
                  if (
                    ele.departureFlight.stopCount >= 2 &&
                    item.departureFlight.stopCount >= 2
                  ) {
                    this.twoStopFlights.splice(idx, 1);
                  }
                });
              });

              /////
              if (
                filterobj.stopsDetails.directchecked == false ||
                filterobj.stopsDetails.onestopchecked == false ||
                filterobj.stopsDetails.twoplusstopchecked == false
              ) {
                this.MainStopFilter = this.oneStopFlights
                  .concat(this.twoStopFlights)
                  .concat(this.NonStopFlights);

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    this.MainStopFilter = flightScheduleData;
                  }
                }

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalReturnStopFilter(
                  this.MainStopFilter,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  this.MainStopFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetails.directchecked == false &&
                  filterobj.stopsDetails.onestopchecked == false &&
                  filterobj.stopsDetails.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilter.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainRefundFilter
                      );
                    }

                    if (
                      filterobj.stopsDetailsReturn.directchecked == true ||
                      filterobj.stopsDetailsReturn.onestopchecked == true ||
                      filterobj.stopsDetailsReturn.twoplusstopchecked == true
                    ) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.MainStopFilterR
                      );
                    }

                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilter = this.MainStopFilter.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilter.length == 0) {
                  this.MainStopFilter = flightScheduleData;
                }

                if (
                  filterobj.stopsDetails.directchecked != false ||
                  filterobj.stopsDetails.onestopchecked != false ||
                  filterobj.stopsDetails.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalStopFilter(
                    this.MainStopFilter,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilter = internalStopFlights;
                }
                let sdup: FlightSchedulesNew[] = [];
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilter,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilter = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilter = internalDayTFlights;
                }

                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilter,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilter = internalAirFlights;
                }


                sdup = this.MainStopFilter;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            }
          }
        }
        if (
          event.target.value == 'RnonStop' ||
          event.target.value == 'RoneStop' ||
          event.target.value == 'RtwoStop'
        ) {
          if (event.target.value == 'RnonStop') {
            RNonStopFlights = flightScheduleData;
            if (filterobj.stopsDetailsReturn.directchecked == true) {
              var nonStoplist = RNonStopFlights.filter(
                (z) => z.returnFlight.stopCount == 0
              );
              this.RNonStopFlights = this.RNonStopFlights.concat(nonStoplist);

              /////
              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainStopFilterR = this.RoneStopFlights.concat(
                  this.RtwoStopFlights
                ).concat(this.RNonStopFlights);

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalStopFilter(
                  this.MainStopFilterR,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainStopFilterR = internalStopF;
                }

                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilterR,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilterR = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilterR,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilterR = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilterR,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilterR = internalAirFlights;
                }

                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilterR;
                this.flightDataCarry = [...new Set(sdup)];
              }

              //////
            } else if (filterobj.stopsDetailsReturn.directchecked == false) {
              var nonStoplist = RNonStopFlights.filter(
                (z) => z.returnFlight.stopCount == 0
              );
              nonStoplist.forEach((ele, index) => {
                this.RNonStopFlights.forEach((item, idx) => {
                  if (
                    item.returnFlight.stopCount == 0 &&
                    ele.returnFlight.stopCount == 0
                  ) {
                    this.RNonStopFlights.splice(idx, 1);
                  }
                });
              });

              /////////
              if (
                filterobj.stopsDetailsReturn.directchecked == false ||
                filterobj.stopsDetailsReturn.onestopchecked == false ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == false
              ) {
                this.MainStopFilterR = this.RoneStopFlights.concat(
                  this.RtwoStopFlights
                ).concat(this.RNonStopFlights);

                if (
                  filterobj.stopsDetailsReturn.directchecked == false &&
                  filterobj.stopsDetailsReturn.onestopchecked == false &&
                  filterobj.stopsDetailsReturn.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilterR.length == 0) {
                    this.MainStopFilterR = flightScheduleData;
                  }
                }

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalStopFilter(
                  this.MainStopFilterR,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainStopFilterR = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == false &&
                  filterobj.stopsDetailsReturn.onestopchecked == false &&
                  filterobj.stopsDetailsReturn.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilterR.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.MainRefundFilter
                      );
                    }
                    if (
                      filterobj.stopsDetails.directchecked == true ||
                      filterobj.stopsDetails.onestopchecked == true ||
                      filterobj.stopsDetails.twoplusstopchecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.MainStopFilter
                      );
                    }
                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilterR.length == 0) {
                  this.MainStopFilterR = flightScheduleData;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked != false ||
                  filterobj.stopsDetailsReturn.onestopchecked != false ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  //////
                  internalStopFlights = this.internalReturnStopFilter(
                    this.MainStopFilterR,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilterR = internalStopFlights;
                }

                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilterR,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilterR = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilter,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilterR = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilterR,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilterR = internalAirFlights;
                }


                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilterR;
                this.flightDataCarry = [...new Set(sdup)];
              }
            }
            //////
          }
          //one Rstop
          if (event.target.value == 'RoneStop') {
            RoneStopFlights = flightScheduleData;
            if (filterobj.stopsDetailsReturn.onestopchecked == true) {
              var oneStopList = RoneStopFlights.filter(
                (x) => x.returnFlight.stopCount == 1
              );
              this.RoneStopFlights = this.RoneStopFlights.concat(oneStopList);

              ////
              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainStopFilterR = this.RoneStopFlights.concat(
                  this.RtwoStopFlights
                ).concat(this.RNonStopFlights);

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalStopFilter(
                  this.MainStopFilterR,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainStopFilterR = internalStopF;
                }

                //
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilterR,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilterR = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilterR,
                  internalDayTFlights, filterobj
                )!;


                let sdup: FlightSchedulesNew[] = [];
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilterR = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilterR,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilterR = internalAirFlights;
                }
                sdup = this.MainStopFilterR;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            } else if (filterobj.stopsDetailsReturn.onestopchecked == false) {
              var oneStopList = RoneStopFlights.filter(
                (x) => x.returnFlight.stopCount == 1
              );
              oneStopList.forEach((item, index) => {
                this.RoneStopFlights.forEach((ele, idx) => {
                  if (
                    ele.returnFlight.stopCount == 1 &&
                    item.returnFlight.stopCount == 1
                  ) {
                    this.RoneStopFlights.splice(idx, 1);
                  }
                });
              });
              /////
              if (
                filterobj.stopsDetailsReturn.directchecked == false ||
                filterobj.stopsDetailsReturn.onestopchecked == false ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == false
              ) {
                this.MainStopFilterR = this.RoneStopFlights.concat(
                  this.RtwoStopFlights
                ).concat(this.RNonStopFlights);

                if (
                  filterobj.stopsDetailsReturn.directchecked == false &&
                  filterobj.stopsDetailsReturn.onestopchecked == false &&
                  filterobj.stopsDetailsReturn.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilterR.length == 0) {
                    this.MainStopFilterR = flightScheduleData;
                  }
                }

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalStopFilter(
                  this.MainStopFilterR,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainStopFilterR = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == false &&
                  filterobj.stopsDetailsReturn.onestopchecked == false &&
                  filterobj.stopsDetailsReturn.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilterR.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.MainRefundFilter
                      );
                    }

                    if (
                      filterobj.stopsDetails.directchecked == true ||
                      filterobj.stopsDetails.onestopchecked == true ||
                      filterobj.stopsDetails.twoplusstopchecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.MainStopFilter
                      );
                    }

                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilterR.length == 0) {
                  this.MainStopFilterR = flightScheduleData;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked != false ||
                  filterobj.stopsDetailsReturn.onestopchecked != false ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalReturnStopFilter(
                    this.MainStopFilterR,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilterR = internalStopFlights;
                }
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilterR,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilterR = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilterR,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilterR = internalDayTFlights;
                }
                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilterR,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilterR = internalAirFlights;
                }


                let sdup: FlightSchedulesNew[] = [];
                sdup = this.MainStopFilterR;

                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            }
          }
          //two Rstop
          if (event.target.value == 'RtwoStop') {
            RtwoStopFlights = flightScheduleData;
            if (filterobj.stopsDetailsReturn.twoplusstopchecked == true) {
              var twoStopList = RtwoStopFlights.filter(
                (y) => y.returnFlight.stopCount >= 2
              ); //
              this.RtwoStopFlights = this.RtwoStopFlights.concat(twoStopList);

              ////
              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainStopFilterR = this.RoneStopFlights.concat(
                  this.RtwoStopFlights
                ).concat(this.RNonStopFlights);

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalStopFilter(
                  this.MainStopFilterR,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainStopFilterR = internalStopF;
                }

                //
                let sdup: FlightSchedulesNew[] = [];
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilterR,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilterR = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilterR,
                  internalDayTFlights, filterobj
                )!;

                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilterR = internalDayTFlights;
                }

                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilterR,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilterR = internalAirFlights;
                }

                sdup = this.MainStopFilterR;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            } else if (filterobj.stopsDetailsReturn.twoplusstopchecked == false) {
              var twoStopList = RtwoStopFlights.filter(
                (y) => y.returnFlight.stopCount >= 2
              );
              twoStopList.forEach((item, index) => {
                this.RtwoStopFlights.forEach((ele, idx) => {
                  if (
                    ele.returnFlight.stopCount >= 2 &&
                    item.returnFlight.stopCount >= 2
                  ) {
                    this.RtwoStopFlights.splice(idx, 1);
                  }
                });
              });

              /////
              if (
                filterobj.stopsDetailsReturn.directchecked == false ||
                filterobj.stopsDetailsReturn.onestopchecked == false ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == false
              ) {
                this.MainStopFilterR = this.RoneStopFlights.concat(
                  this.RtwoStopFlights
                ).concat(this.RNonStopFlights);

                if (
                  filterobj.stopsDetailsReturn.directchecked == false &&
                  filterobj.stopsDetailsReturn.onestopchecked == false &&
                  filterobj.stopsDetailsReturn.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilterR.length == 0) {
                    this.MainStopFilterR = flightScheduleData;
                  }
                }

                let dup: FlightSchedulesNew[] = [];
                let internalStopF: FlightSchedulesNew[] = [];
                internalStopF = this.internalStopFilter(
                  this.MainStopFilterR,
                  internalStopF, filterobj
                )!;
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainStopFilterR = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == false &&
                  filterobj.stopsDetailsReturn.onestopchecked == false &&
                  filterobj.stopsDetailsReturn.twoplusstopchecked == false
                ) {
                  if (this.MainStopFilterR.length == 0) {
                    if (
                      filterobj.timeList.morningChecked == true ||
                      filterobj.timeList.afternoonChecked == true ||
                      filterobj.timeList.eveningChecked == true ||
                      filterobj.timeList.nightChecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.mainTimingFilter
                      );
                    }
                    if (
                      filterobj.fareType.refundableFlightschecked == true ||
                      filterobj.fareType.nonRefundableFlightschecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.MainRefundFilter
                      );
                    }
                    if (
                      filterobj.stopsDetails.directchecked == true ||
                      filterobj.stopsDetails.onestopchecked == true ||
                      filterobj.stopsDetails.twoplusstopchecked == true
                    ) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.MainStopFilter
                      );
                    }
                    if (this.flightNamesForFilter.length > 0) {
                      this.MainStopFilterR = this.MainStopFilterR.concat(
                        this.mainairlinesFilter
                      );
                    }
                  }
                }

                if (this.MainStopFilterR.length == 0) {
                  this.MainStopFilterR = flightScheduleData;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked != false ||
                  filterobj.stopsDetailsReturn.onestopchecked != false ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked != false
                ) {
                  let internalStopFlights: FlightSchedulesNew[] = [];
                  internalStopFlights = this.internalReturnStopFilter(
                    this.MainStopFilterR,
                    internalStopFlights, filterobj
                  )!;
                  this.MainStopFilterR = internalStopFlights;
                }
                let sdup: FlightSchedulesNew[] = [];
                let internalRefFlights: FlightSchedulesNew[] = [];
                internalRefFlights = this.internalRefundFilter(
                  this.MainStopFilterR,
                  internalRefFlights, filterobj
                )!;
                if (
                  filterobj.fareType.refundableFlightschecked == true ||
                  filterobj.fareType.nonRefundableFlightschecked == true
                ) {
                  this.MainStopFilterR = internalRefFlights;
                }
                let internalDayTFlights: FlightSchedulesNew[] = [];
                internalDayTFlights = this.internalDaysTimeFilter(
                  this.MainStopFilterR,
                  internalDayTFlights, filterobj
                )!;
                if (
                  filterobj.timeList.morningChecked == true ||
                  filterobj.timeList.afternoonChecked == true ||
                  filterobj.timeList.eveningChecked == true ||
                  filterobj.timeList.nightChecked == true
                ) {
                  this.MainStopFilterR = internalDayTFlights;
                }

                let internalAirFlights: FlightSchedulesNew[] = [];
                internalAirFlights = this.internalAirlinesFilter(
                  this.MainStopFilterR,
                  internalAirFlights
                )!;
                if (this.flightNamesForFilter.length > 0) {
                  this.MainStopFilterR = internalAirFlights;
                }

                sdup = this.MainStopFilterR;
                this.flightDataCarry = [...new Set(sdup)];
              }
              ////
            }
          }
        }
      }

      /////////////////////////////////////////////////Stop Filter End///////
      /////////////////////////////////////////////////Refundable Filter///////

      let RefundableFlights: FlightSchedulesNew[];
      let NonRefundableFlights: FlightSchedulesNew[];
      if (
        event.target.value == 'refundable' ||
        event.target.value == 'nonRefundable'
      ) {
        if (event.target.value == 'refundable') {
          RefundableFlights = flightScheduleData;

          if (filterobj.fareType.refundableFlightschecked == true) {
            var refundList = RefundableFlights.filter(
              (x) => x.departureFlight.nonRefundable == false
            );
            this.RefundableFlights = this.RefundableFlights.concat(refundList);
            ////
            if (
              filterobj.fareType.refundableFlightschecked == true ||
              filterobj.fareType.nonRefundableFlightschecked == true
            ) {
              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );
              let dup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];

              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.MainRefundFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.MainRefundFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainRefundFilter = internalStopF;
                }
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.MainRefundFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopFR;
              }

              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }


              dup = this.MainRefundFilter;
              this.flightDataCarry = [...new Set(dup)];
            }
            ////
          } else if (filterobj.fareType.refundableFlightschecked == false) {
            var refundList = RefundableFlights.filter(
              (x) => x.departureFlight.nonRefundable == false
            );
            refundList.forEach((ele, index) => {
              this.RefundableFlights.forEach((item, idx) => {
                if (
                  item.departureFlight.nonRefundable ==
                  ele.departureFlight.nonRefundable &&
                  item.departureFlight.airlineLegalName ==
                  ele.departureFlight.airlineLegalName &&
                  item.departureFlight.departure.time ==
                  ele.departureFlight.departure.time
                )
                  this.RefundableFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.fareType.nonRefundableFlightschecked == false ||
              filterobj.fareType.refundableFlightschecked == false
            ) {
              let dup: FlightSchedulesNew[] = [];
              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );
              if (
                filterobj.fareType.nonRefundableFlightschecked == false &&
                filterobj.fareType.refundableFlightschecked == false
              ) {
                if (this.MainRefundFilter.length == 0) {
                  if (
                    filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.afternoonChecked == true ||
                    filterobj.timeList.eveningChecked == true ||
                    filterobj.timeList.nightChecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.MainRefundFilter.length == 0) {
                this.MainRefundFilter = flightScheduleData;
              }

              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.MainRefundFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.MainRefundFilter,
                    internalStopF, filterobj
                  )!;
                }
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainRefundFilter = internalStopF;
                }
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.MainRefundFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }

              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilter(
                this.MainRefundFilter,
                internalRefFlights, filterobj
              )!;
              if (filterobj.fareType.nonRefundableFlightschecked == true) {
                this.MainRefundFilter = internalRefFlights;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }


              dup = this.MainRefundFilter;
              this.flightDataCarry = [...new Set(dup)];
              dup = this.MainRefundFilter;
            }
            //////
          }
        }

        if (event.target.value == 'nonRefundable') {
          NonRefundableFlights = flightScheduleData;

          if (filterobj.fareType.nonRefundableFlightschecked == true) {
            var nonRefundList = NonRefundableFlights.filter(
              (x) => x.departureFlight.nonRefundable == true
            );

            this.NonRefundableFlights =
              this.NonRefundableFlights.concat(nonRefundList);
            ////
            if (
              filterobj.fareType.refundableFlightschecked == true ||
              filterobj.fareType.nonRefundableFlightschecked == true
            ) {
              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );

              let dup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.MainRefundFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.MainRefundFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainRefundFilter = internalStopF;
                }
                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.MainRefundFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }

              dup = this.MainRefundFilter;

              this.flightDataCarry = [...new Set(dup)];
            }
            ////
          } else if (filterobj.fareType.nonRefundableFlightschecked == false) {
            var nonRefundList = NonRefundableFlights.filter(
              (x) => x.departureFlight.nonRefundable == true
            );
            nonRefundList.forEach((ele, index) => {
              this.NonRefundableFlights.forEach((item, idx) => {
                if (
                  item.departureFlight.nonRefundable ==
                  ele.departureFlight.nonRefundable &&
                  item.departureFlight.airlineLegalName ==
                  ele.departureFlight.airlineLegalName &&
                  item.departureFlight.departure.time ==
                  ele.departureFlight.departure.time
                )
                  this.NonRefundableFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.fareType.nonRefundableFlightschecked == false ||
              filterobj.fareType.refundableFlightschecked == false
            ) {
              let dup: FlightSchedulesNew[] = [];

              this.MainRefundFilter = this.NonRefundableFlights.concat(
                this.RefundableFlights
              );
              if (
                filterobj.fareType.nonRefundableFlightschecked == false &&
                filterobj.fareType.refundableFlightschecked == false
              ) {
                if (this.MainRefundFilter.length == 0) {
                  if (
                    filterobj.timeList.morningChecked == true ||
                    filterobj.timeList.afternoonChecked == true ||
                    filterobj.timeList.eveningChecked == true ||
                    filterobj.timeList.nightChecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainTimingFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.MainRefundFilter = this.MainRefundFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.MainRefundFilter.length == 0) {
                this.MainRefundFilter = flightScheduleData;
              }
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.MainRefundFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.MainRefundFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.MainRefundFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.MainRefundFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.MainRefundFilter = internalStopF;
              }

              let internalRefFlights: FlightSchedulesNew[] = [];
              internalRefFlights = this.internalRefundFilter(
                this.MainRefundFilter,
                internalRefFlights, filterobj
              )!;
              if (filterobj.fareType.refundableFlightschecked == true) {
                this.MainRefundFilter = internalRefFlights;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.MainRefundFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.MainRefundFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.MainRefundFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.MainRefundFilter = internalAirFlights;
              }


              dup = this.MainRefundFilter;
              this.flightDataCarry = [...new Set(dup)];
            }
            //////
          }
        }
      }

      /////////////////////////////////////////////////Refundable Filter End///////
      /////////////////////////////////////////////////Timing Filter Start///////
      let morninglo: FlightSchedulesNew[];
      let afternoonlo: FlightSchedulesNew[];
      let nightlo: FlightSchedulesNew[];
      let midnightlo: FlightSchedulesNew[];
      if (
        event.target.value == 'Morning' ||
        event.target.value == 'Afternoon' ||
        event.target.value == 'Night' ||
        event.target.value == 'Midnight'
      ) {
        if (event.target.value == 'Morning') {
          morninglo = flightScheduleData;
          if (filterobj.timeList.morningChecked == true) {
            var morninglist = morninglo.filter(
              (z) =>
                z.departureFlight.departure.time >= '05:00' &&
                z.departureFlight.departure.time <= '11:59'
            );
            this.morningFlights = this.morningFlights.concat(morninglist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              let filterStop = false;
              let filterRefund = false;
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  filterStop = true;
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                filterStop = true;
                this.mainTimingFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                filterStop = true;
                this.mainTimingFilter = internalStopF;
              }

              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                filterRefund = true;
                if (filterStop == true) {
                  this.mainTimingFilter = internlRefundTimeF;
                }
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.morningChecked == false) {
            var morninglist = morninglo.filter(
              (z) =>
                z.departureFlight.departure.time >= '05:00' &&
                z.departureFlight.departure.time <= '11:59'
            );

            morninglist.forEach((item, index, array) => {
              this.morningFlights.forEach((im, idx, ar) => {
                if (
                  item.departureFlight.departure.time ==
                  im.departureFlight.departure.time &&
                  item.departureFlight.airlineLegalName ==
                  im.departureFlight.airlineLegalName
                )
                  this.morningFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }

              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }
              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];
              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }

              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }

              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }
              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
        //Afternoon
        if (event.target.value == 'Afternoon') {
          afternoonlo = flightScheduleData;
          if (filterobj.timeList.afternoonChecked == true) {
            var afternoonlist = afternoonlo.filter(
              (z) =>
                z.departureFlight.departure.time >= '12:00' &&
                z.departureFlight.departure.time <= '17:59'
            );
            this.afternoonFlights = this.afternoonFlights.concat(afternoonlist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }

              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }


              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.afternoonChecked == false) {
            var afternoonlist = afternoonlo.filter(
              (z) =>
                z.departureFlight.departure.time >= '12:00' &&
                z.departureFlight.departure.time <= '17:59'
            );
            afternoonlist.forEach((item, index, array) => {
              this.afternoonFlights.forEach((im, idx, ar) => {
                if (
                  item.departureFlight.departure.time ==
                  im.departureFlight.departure.time &&
                  item.departureFlight.airlineLegalName ==
                  im.departureFlight.airlineLegalName
                )
                  this.afternoonFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }
              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }

              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.eveningChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
        //night
        if (event.target.value == 'Night') {
          nightlo = flightScheduleData;
          if (filterobj.timeList.eveningChecked == true) {
            var nightlist = nightlo.filter(
              (z) =>
                z.departureFlight.departure.time >= '18:00' &&
                z.departureFlight.departure.time <= '23:59'
            );
            this.nightFlights = this.nightFlights.concat(nightlist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              //let internalSortFlights: FlightSchedulesNew[] = [];
              //internalSortFlights = this.sortingInternal(
              //  this.mainTimingFilter,
              //  internalSortFlights
              //)!;
              //if (internalSortFlights.length > 0) {
              //  this.mainTimingFilter = internalSortFlights;
              //}

              sdup = this.mainTimingFilter;
              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.eveningChecked == false) {
            var nightlist = nightlo.filter(
              (z) =>
                z.departureFlight.departure.time >= '18:00' &&
                z.departureFlight.departure.time <= '23:59'
            );
            nightlist.forEach((item, index, array) => {
              this.nightFlights.forEach((im, idx, ar) => {
                if (
                  item.departureFlight.departure.time ==
                  im.departureFlight.departure.time &&
                  item.departureFlight.airlineLegalName ==
                  im.departureFlight.airlineLegalName
                )
                  this.nightFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);
              //

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }

              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.nightChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              //let internalSortFlights: FlightSchedulesNew[] = [];
              //internalSortFlights = this.sortingInternal(
              //  this.mainTimingFilter,
              //  internalSortFlights
              //)!;
              //if (internalSortFlights.length > 0) {
              //  this.mainTimingFilter = internalSortFlights;
              //}

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
        //midnight
        if (event.target.value == 'Midnight') {
          midnightlo = flightScheduleData;
          if (filterobj.timeList.nightChecked == true) {
            var midnightlist = midnightlo.filter(
              (z) =>
                z.departureFlight.departure.time >= '00:00' &&
                z.departureFlight.departure.time <= '04:59'
            );
            this.midnightFlights = this.midnightFlights.concat(midnightlist);
            /////
            if (
              filterobj.timeList.morningChecked == true ||
              filterobj.timeList.afternoonChecked == true ||
              filterobj.timeList.eveningChecked == true ||
              filterobj.timeList.nightChecked == true
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              //let internalSortFlights: FlightSchedulesNew[] = [];
              //internalSortFlights = this.sortingInternal(
              //  this.mainTimingFilter,
              //  internalSortFlights
              //)!;
              //if (internalSortFlights.length > 0) {
              //  this.mainTimingFilter = internalSortFlights;
              //}

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          } else if (filterobj.timeList.nightChecked == false) {
            var midnightlist = midnightlo.filter(
              (z) =>
                z.departureFlight.departure.time >= '00:00' &&
                z.departureFlight.departure.time <= '04:59'
            );
            midnightlist.forEach((item, index, array) => {
              this.midnightFlights.forEach((im, idx, ar) => {
                if (
                  item.departureFlight.departure.time ==
                  im.departureFlight.departure.time &&
                  item.departureFlight.airlineLegalName ==
                  im.departureFlight.airlineLegalName
                )
                  this.midnightFlights.splice(idx, 1);
              });
            });
            /////
            if (
              filterobj.timeList.morningChecked == false ||
              filterobj.timeList.afternoonChecked == false ||
              filterobj.timeList.eveningChecked == false ||
              filterobj.timeList.nightChecked == false
            ) {
              this.mainTimingFilter = this.morningFlights
                .concat(this.afternoonFlights)
                .concat(this.nightFlights)
                .concat(this.midnightFlights);
              //

              if (
                filterobj.timeList.morningChecked == false &&
                filterobj.timeList.afternoonChecked == false &&
                filterobj.timeList.eveningChecked == false &&
                filterobj.timeList.nightChecked == false
              ) {
                if (this.mainTimingFilter.length == 0) {
                  if (
                    filterobj.fareType.nonRefundableFlightschecked == true ||
                    filterobj.fareType.refundableFlightschecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainRefundFilter
                    );
                  }
                  if (
                    filterobj.stopsDetails.directchecked == true ||
                    filterobj.stopsDetails.onestopchecked == true ||
                    filterobj.stopsDetails.twoplusstopchecked == true
                  ) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.MainStopFilter
                    );
                  }
                  if (this.flightNamesForFilter.length > 0) {
                    this.mainTimingFilter = this.mainTimingFilter.concat(
                      this.mainairlinesFilter
                    );
                  }
                }
              }
              if (this.mainTimingFilter.length == 0) {
                this.mainTimingFilter = flightScheduleData;
              }

              this.mainTimingFilter = [...new Set(this.mainTimingFilter)];

              let sdup: FlightSchedulesNew[] = [];
              let internalStopF: FlightSchedulesNew[] = [];
              let internalStopFR: FlightSchedulesNew[] = [];
              if (searchObj.flightLocationInfo.length == 1) {
                internalStopF = this.internalStopFilter(
                  this.mainTimingFilter,
                  internalStopF, filterobj
                )!;
              } else if (searchObj.flightLocationInfo.length == 2) {
                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  internalStopF = this.internalStopFilter(
                    this.mainTimingFilter,
                    internalStopF, filterobj
                  )!;
                }

                if (
                  filterobj.stopsDetails.directchecked == true ||
                  filterobj.stopsDetails.onestopchecked == true ||
                  filterobj.stopsDetails.twoplusstopchecked == true
                ) {
                  this.mainTimingFilter = internalStopF;
                }

                if (
                  filterobj.stopsDetailsReturn.directchecked == true ||
                  filterobj.stopsDetailsReturn.onestopchecked == true ||
                  filterobj.stopsDetailsReturn.twoplusstopchecked == true
                ) {
                  internalStopFR = this.internalReturnStopFilter(
                    this.mainTimingFilter,
                    internalStopFR, filterobj
                  )!;
                }
              }

              if (
                filterobj.stopsDetailsReturn.directchecked == true ||
                filterobj.stopsDetailsReturn.onestopchecked == true ||
                filterobj.stopsDetailsReturn.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopFR;
              }
              if (
                filterobj.stopsDetails.directchecked == true ||
                filterobj.stopsDetails.onestopchecked == true ||
                filterobj.stopsDetails.twoplusstopchecked == true
              ) {
                this.mainTimingFilter = internalStopF;
              }
              let internlRefundTimeF: FlightSchedulesNew[] = [];
              internlRefundTimeF = this.internalRefundFilter(
                this.mainTimingFilter,
                internlRefundTimeF, filterobj
              )!;
              if (
                filterobj.fareType.refundableFlightschecked == true ||
                filterobj.fareType.nonRefundableFlightschecked == true
              ) {
                this.mainTimingFilter = internlRefundTimeF;
              }

              let internaldayTimeF: FlightSchedulesNew[] = [];
              internaldayTimeF = this.internalDaysTimeFilter(
                this.mainTimingFilter,
                internaldayTimeF, filterobj
              )!;
              if (
                filterobj.timeList.morningChecked == true ||
                filterobj.timeList.afternoonChecked == true ||
                filterobj.timeList.eveningChecked == true
              ) {
                this.mainTimingFilter = internaldayTimeF;
              }

              let internalAirFlights: FlightSchedulesNew[] = [];
              internalAirFlights = this.internalAirlinesFilter(
                this.mainTimingFilter,
                internalAirFlights
              )!;
              if (this.flightNamesForFilter.length > 0) {
                this.mainTimingFilter = internalAirFlights;
              }

              //let internalSortFlights: FlightSchedulesNew[] = [];
              //internalSortFlights = this.sortingInternal(
              //  this.mainTimingFilter,
              //  internalSortFlights
              //)!;
              //if (internalSortFlights.length > 0) {
              //  this.mainTimingFilter = internalSortFlights;
              //}

              sdup = this.mainTimingFilter;

              this.flightDataCarry = [...new Set(sdup)];
            }
            /////
          }
        }
      }

      /////////////////////////////////////////////////Timing Filter End///////
      /////////////////////////////////////////////////Airline Filter Start///////

      let airlineslo: FlightSchedulesNew[];
      let useInFilters: FlightSchedulesNew[] = [];
      if (event.target.checked == true && value == 'airlines') {
        airlineslo = flightScheduleData;
        this.flightNamesForFilter.push(event.target.value);
        if (this.flightNamesForFilter.length > 0) {
          this.mainairlinesFilter = [];
          for (let a = 0; a < this.flightNamesForFilter.length; a++) {
            var airlineList = airlineslo.filter(
              (x) =>
                x.departureFlight.airlineLegalName ==
                this.flightNamesForFilter[a]
            );
            this.mainairlinesFilter =
              this.mainairlinesFilter.concat(airlineList);
          }
        }
        ////

        let sdup: FlightSchedulesNew[] = [];
        let internalStopF: FlightSchedulesNew[] = [];
        let internalStopFR: FlightSchedulesNew[] = [];
        if (searchObj.flightLocationInfo.length == 1) {
          internalStopF = this.internalStopFilter(
            this.mainairlinesFilter,
            internalStopF, filterobj
          )!;
        } else if (searchObj.flightLocationInfo.length == 2) {
          if (
            filterobj.stopsDetails.directchecked == true ||
            filterobj.stopsDetails.onestopchecked == true ||
            filterobj.stopsDetails.twoplusstopchecked == true
          ) {
            internalStopF = this.internalStopFilter(
              this.mainairlinesFilter,
              internalStopF, filterobj
            )!;
          }

          if (
            filterobj.stopsDetails.directchecked == true ||
            filterobj.stopsDetails.onestopchecked == true ||
            filterobj.stopsDetails.twoplusstopchecked == true
          ) {
            this.mainairlinesFilter = internalStopF;
          }

          if (
            filterobj.stopsDetailsReturn.directchecked == true ||
            filterobj.stopsDetailsReturn.onestopchecked == true ||
            filterobj.stopsDetailsReturn.twoplusstopchecked == true
          ) {
            internalStopFR = this.internalReturnStopFilter(
              this.mainairlinesFilter,
              internalStopFR, filterobj
            )!;
          }
        }

        if (
          filterobj.stopsDetailsReturn.directchecked == true ||
          filterobj.stopsDetailsReturn.onestopchecked == true ||
          filterobj.stopsDetailsReturn.twoplusstopchecked == true
        ) {
          this.mainairlinesFilter = internalStopFR;
        }
        if (
          filterobj.stopsDetails.directchecked == true ||
          filterobj.stopsDetails.onestopchecked == true ||
          filterobj.stopsDetails.twoplusstopchecked == true
        ) {
          this.mainairlinesFilter = internalStopF;
        }
        let internlRefundTimeF: FlightSchedulesNew[] = [];
        internlRefundTimeF = this.internalRefundFilter(
          this.mainairlinesFilter,
          internlRefundTimeF, filterobj
        )!;
        if (
          filterobj.fareType.refundableFlightschecked == true ||
          filterobj.fareType.nonRefundableFlightschecked == true
        ) {
          this.mainairlinesFilter = internlRefundTimeF;
        }
        let internaldayTimeF: FlightSchedulesNew[] = [];
        internaldayTimeF = this.internalDaysTimeFilter(
          this.mainairlinesFilter,
          internaldayTimeF, filterobj
        )!;
        if (
          filterobj.timeList.morningChecked == true ||
          filterobj.timeList.afternoonChecked == true ||
          filterobj.timeList.eveningChecked == true ||
          filterobj.timeList.nightChecked == true
        ) {
          this.mainairlinesFilter = internaldayTimeF;
        }


        sdup = this.mainairlinesFilter;

        this.flightDataCarry = [...new Set(sdup)];
      } else if (event.target.checked == false && value == 'airlines') {
        airlineslo = flightScheduleData;

        if (this.flightNamesForFilter.length > 0) {
          this.mainairlinesFilter = [];
          for (let a = 0; a < this.flightNamesForFilter.length; a++) {
            var airlineList = airlineslo.filter(
              (x) =>
                x.departureFlight.airlineLegalName ==
                this.flightNamesForFilter[a]
            );
            this.mainairlinesFilter =
              this.mainairlinesFilter.concat(airlineList);
          }
        }

        const name = event.target.value;
        var airlineList = airlineslo.filter(
          (x) => x.departureFlight.airlineLegalName == name
        );
        airlineList.forEach((ele, index) => {
          this.mainairlinesFilter.forEach((item, idx) => {
            if (
              item.departureFlight.airlineLegalName == name &&
              ele.departureFlight.airlineLegalName == name
            ) {
              this.mainairlinesFilter.splice(idx, 1);
            }
          });
        });

        let deletingAirlineIndex = this.flightNamesForFilter.findIndex(
          (ele) => ele == event.target.value
        );
        this.flightNamesForFilter.splice(deletingAirlineIndex, 1);
        ////
        if (this.mainairlinesFilter.length == 0) {
          if (
            filterobj.timeList.morningChecked == false &&
            filterobj.timeList.afternoonChecked == false &&
            filterobj.timeList.eveningChecked == false &&
            filterobj.timeList.nightChecked == false
          ) {
            this.mainairlinesFilter = this.mainairlinesFilter.concat(
              this.mainTimingFilter
            );
          }

          if (
            filterobj.fareType.nonRefundableFlightschecked == true ||
            filterobj.fareType.refundableFlightschecked == true
          ) {
            this.mainairlinesFilter = this.mainairlinesFilter.concat(
              this.MainRefundFilter
            );
          }
          if (
            filterobj.stopsDetails.directchecked == true ||
            filterobj.stopsDetails.onestopchecked == true ||
            filterobj.stopsDetails.twoplusstopchecked == true
          ) {
            this.mainairlinesFilter = this.mainairlinesFilter.concat(
              this.MainStopFilter
            );
          }
        }

        if (this.mainairlinesFilter.length == 0) {
          this.mainairlinesFilter = flightScheduleData;
        }

        let sdup: FlightSchedulesNew[] = [];
        let internalStopF: FlightSchedulesNew[] = [];
        let internalStopFR: FlightSchedulesNew[] = [];
        if (searchObj.flightLocationInfo.length == 1) {
          internalStopF = this.internalStopFilter(
            this.mainairlinesFilter,
            internalStopF, filterobj
          )!;
        } else if (searchObj.flightLocationInfo.length == 2) {
          if (
            filterobj.stopsDetails.directchecked == true ||
            filterobj.stopsDetails.onestopchecked == true ||
            filterobj.stopsDetails.twoplusstopchecked == true
          ) {
            internalStopF = this.internalStopFilter(
              this.mainairlinesFilter,
              internalStopF, filterobj
            )!;
          }

          if (
            filterobj.stopsDetails.directchecked == true ||
            filterobj.stopsDetails.onestopchecked == true ||
            filterobj.stopsDetails.twoplusstopchecked == true
          ) {
            this.mainairlinesFilter = internalStopF;
          }

          if (
            filterobj.stopsDetailsReturn.directchecked == true ||
            filterobj.stopsDetailsReturn.onestopchecked == true ||
            filterobj.stopsDetailsReturn.twoplusstopchecked == true
          ) {
            internalStopFR = this.internalReturnStopFilter(
              this.mainairlinesFilter,
              internalStopFR, filterobj
            )!;
          }
        }

        if (
          filterobj.stopsDetailsReturn.directchecked == true ||
          filterobj.stopsDetailsReturn.onestopchecked == true ||
          filterobj.stopsDetailsReturn.twoplusstopchecked == true
        ) {
          this.mainairlinesFilter = internalStopFR;
        }

        if (
          filterobj.stopsDetails.directchecked == true ||
          filterobj.stopsDetails.onestopchecked == true ||
          filterobj.stopsDetails.twoplusstopchecked == true
        ) {
          this.mainairlinesFilter = internalStopF;
        }
        let internlRefundTimeF: FlightSchedulesNew[] = [];
        internlRefundTimeF = this.internalRefundFilter(
          this.mainairlinesFilter,
          internlRefundTimeF, filterobj
        )!;
        if (
          filterobj.fareType.refundableFlightschecked == true ||
          filterobj.fareType.nonRefundableFlightschecked == true
        ) {
          this.mainairlinesFilter = internlRefundTimeF;
        }
        let internaldayTimeF: FlightSchedulesNew[] = [];
        internaldayTimeF = this.internalDaysTimeFilter(
          this.mainairlinesFilter,
          internaldayTimeF, filterobj
        )!;
        if (
          filterobj.timeList.morningChecked == true ||
          filterobj.timeList.afternoonChecked == true ||
          filterobj.timeList.eveningChecked == true ||
          filterobj.timeList.nightChecked == true
        ) {
          this.mainairlinesFilter = internaldayTimeF;
        }



        sdup = this.mainairlinesFilter;

        this.flightDataCarry = [...new Set(sdup)];
      }
      /////////////////////////////////////////////////Airline Filter End///////
    }
    return this.flightDataCarry;
    /////////////////////////////One Way End////////////////////////////
  }  internalStopFilterMulti(tempFilter: FlightSchedulesNew[], internalStopFlights: FlightSchedulesNew[], filterobj: FilterFlightResultBinding): FlightSchedulesNew[] {
    if (filterobj.stopsDetails.directchecked == true) {
      let non = tempFilter.filter((z) => z.multiFlights[0].stopCount == 0);

      internalStopFlights = internalStopFlights.concat(non);
    }

    if (filterobj.stopsDetails.onestopchecked == true) {
      let one = tempFilter.filter((x) => x.multiFlights[0].stopCount == 1);

      internalStopFlights = internalStopFlights.concat(one);
    }

    if (filterobj.stopsDetails.twoplusstopchecked == true) {
      let two = tempFilter.filter((y) => y.multiFlights[0].stopCount >= 2);

      internalStopFlights = internalStopFlights.concat(two);
    }

    return internalStopFlights;
  }

  internalStopFilter(
    tempFilter: FlightSchedulesNew[],
    internalStopFlights: FlightSchedulesNew[], filterobj: FilterFlightResultBinding
  ): FlightSchedulesNew[] {
    if (filterobj.stopsDetails.directchecked == true) {
      let non = tempFilter.filter((z) => z.departureFlight.stopCount == 0);

      internalStopFlights = internalStopFlights.concat(non);
    }

    if (filterobj.stopsDetails.onestopchecked == true) {
      let one = tempFilter.filter((x) => x.departureFlight.stopCount == 1);

      internalStopFlights = internalStopFlights.concat(one);
    }

    if (filterobj.stopsDetails.twoplusstopchecked == true) {
      let two = tempFilter.filter((y) => y.departureFlight.stopCount >= 2);

      internalStopFlights = internalStopFlights.concat(two);
    }

    return internalStopFlights;
  }
  internalReturnStopFilter(
    tempFilter: FlightSchedulesNew[],
    internalStopFlights: FlightSchedulesNew[], filterobj: FilterFlightResultBinding
  ): FlightSchedulesNew[] {
    if (filterobj.stopsDetailsReturn.directchecked == true) {
      let non = tempFilter.filter((z) => z.returnFlight.stopCount == 0);

      internalStopFlights = internalStopFlights.concat(non);
    }

    if (filterobj.stopsDetailsReturn.onestopchecked == true) {
      let one = tempFilter.filter((x) => x.returnFlight.stopCount == 1);

      internalStopFlights = internalStopFlights.concat(one);
    }

    if (filterobj.stopsDetailsReturn.twoplusstopchecked == true) {
      let two = tempFilter.filter((y) => y.returnFlight.stopCount >= 2);

      internalStopFlights = internalStopFlights.concat(two);
    }

    return internalStopFlights;
  }
  internalDaysTimeFilter(
    tempFilter: FlightSchedulesNew[],
    internalDatTimeFlights: FlightSchedulesNew[], filterobj: FilterFlightResultBinding
  ): FlightSchedulesNew[] {
    if (filterobj.timeList.morningChecked == true) {
      var morninglist = tempFilter.filter(
        (z) =>
          z.departureFlight.departure.time >= '05:00' &&
          z.departureFlight.departure.time <= '11:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(morninglist);
    }
    if (filterobj.timeList.afternoonChecked == true) {
      var afternoonlist = tempFilter.filter(
        (z) =>
          z.departureFlight.departure.time >= '12:00' &&
          z.departureFlight.departure.time <= '17:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(afternoonlist);
    }
    if (filterobj.timeList.eveningChecked == true) {
      var nightlist = tempFilter.filter(
        (z) =>
          z.departureFlight.departure.time >= '18:00' &&
          z.departureFlight.departure.time <= '23:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(nightlist);
    }

    if (filterobj.timeList.nightChecked == true) {
      var midnightlist = tempFilter.filter(
        (z) =>
          z.departureFlight.departure.time >= '00:00' &&
          z.departureFlight.departure.time <= '04:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(midnightlist);
    }

    return internalDatTimeFlights;
  }

  internalAirlinesFilter(
    tempFilter: FlightSchedulesNew[],
    internalAirlineFlights: FlightSchedulesNew[]
  ): FlightSchedulesNew[] {
    if (this.flightNamesForFilter.length > 0) {
      for (let a = 0; a < this.flightNamesForFilter.length; a++) {
        var airlineList = tempFilter.filter(
          (x) =>
            x.departureFlight.airlineLegalName == this.flightNamesForFilter[a]
        );

        internalAirlineFlights = internalAirlineFlights.concat(airlineList);
      }
    }

    return internalAirlineFlights;
  }

  internalRefundFilter(
    tempFilter: FlightSchedulesNew[],
    internalRefundFlights: FlightSchedulesNew[], filterobj: FilterFlightResultBinding
  ): FlightSchedulesNew[] {
    let stopCounter = 0;

    if (filterobj.fareType.refundableFlightschecked == true) {
      var ref = tempFilter.filter(
        (x) => x.departureFlight.nonRefundable == false
      );

      internalRefundFlights = internalRefundFlights.concat(ref);
    }
    if (filterobj.fareType.nonRefundableFlightschecked == true) {
      var nonref = tempFilter.filter(
        (x) => x.departureFlight.nonRefundable == true
      );

      internalRefundFlights = internalRefundFlights.concat(nonref);
    }

    return internalRefundFlights;
  }





  internalDaysTimeFilterMulti(
    tempFilter: FlightSchedulesNew[],
    internalDatTimeFlights: FlightSchedulesNew[], filteorbj: FilterFlightResultBinding
  ): FlightSchedulesNew[] {
    if (filteorbj.timeList.morningChecked == true) {
      var morninglist = tempFilter.filter(
        (z) =>
          z.multiFlights[0].departure.time >= '05:00' &&
          z.multiFlights[0].departure.time <= '11:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(morninglist);
    }
    if (filteorbj.timeList.afternoonChecked == true) {
      var afternoonlist = tempFilter.filter(
        (z) =>
          z.multiFlights[0].departure.time >= '12:00' &&
          z.multiFlights[0].departure.time <= '17:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(afternoonlist);
    }
    if (filteorbj.timeList.eveningChecked == true) {
      var nightlist = tempFilter.filter(
        (z) =>
          z.multiFlights[0].departure.time >= '18:00' &&
          z.multiFlights[0].departure.time <= '23:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(nightlist);
    }

    if (filteorbj.timeList.nightChecked == true) {
      var midnightlist = tempFilter.filter(
        (z) =>
          z.multiFlights[0].departure.time >= '00:00' &&
          z.multiFlights[0].departure.time <= '04:59'
      );

      internalDatTimeFlights = internalDatTimeFlights.concat(midnightlist);
    }

    return internalDatTimeFlights;
  }

  internalAirlinesFilterMulti(
    tempFilter: FlightSchedulesNew[],
    internalAirlineFlights: FlightSchedulesNew[]
  ): FlightSchedulesNew[] {
    if (this.flightNamesForFilter.length > 0) {
      for (let a = 0; a < this.flightNamesForFilter.length; a++) {
        var airlineList = tempFilter.filter(
          (x) =>
            x.multiFlights[0].airlineLegalName == this.flightNamesForFilter[a]
        );

        internalAirlineFlights = internalAirlineFlights.concat(airlineList);
      }
    }

    return internalAirlineFlights;
  }

  internalRefundFilterMulti(
    tempFilter: FlightSchedulesNew[],
    internalRefundFlights: FlightSchedulesNew[], filterobj: FilterFlightResultBinding
  ): FlightSchedulesNew[] {
    let stopCounter = 0;

    if (filterobj.fareType.refundableFlightschecked == true) {
      var ref = tempFilter.filter(
        (x) => x.multiFlights[0].nonRefundable == false
      );

      internalRefundFlights = internalRefundFlights.concat(ref);
    }
    if (filterobj.fareType.nonRefundableFlightschecked == true) {
      var nonref = tempFilter.filter(
        (x) => x.multiFlights[0].nonRefundable == true
      );

      internalRefundFlights = internalRefundFlights.concat(nonref);
    }

    return internalRefundFlights;
  }

  sortingInternalMulti(
    tempFilter: FlightSchedulesNew[],
    sortingFilter: FlightSchedulesNew[]
  ): FlightSchedulesNew[] {
    //sort by
    var ele = document.getElementById('filterSort') as HTMLSelectElement;
    let selectedValue = ele.options[ele.selectedIndex].value;
    if (selectedValue != 'Sort by') {
      if (selectedValue == 'lowestPrice') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.multiFlights[0].agencyTotalPrice.slice(3)) -
            parseFloat(b.multiFlights[0].agencyTotalPrice.slice(3))
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'highestPrice') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.multiFlights[0].agencyTotalPrice.slice(3)) -
            parseFloat(a.multiFlights[0].agencyTotalPrice.slice(3))
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'shortestDuration') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.multiFlights[0].elapsedTime) -
            parseFloat(b.multiFlights[0].elapsedTime)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'highestDuration') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.multiFlights[0].elapsedTime) -
            parseFloat(a.multiFlights[0].elapsedTime)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'earliestDeparture') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.multiFlights[0].departure.time) -
            parseFloat(b.multiFlights[0].departure.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'latestDeparture') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.multiFlights[0].departure.time) -
            parseFloat(a.multiFlights[0].departure.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'earliestArrival') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.multiFlights[0].arrival.time) -
            parseFloat(b.multiFlights[0].arrival.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'latestArrival') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.multiFlights[0].arrival.time) -
            parseFloat(a.multiFlights[0].arrival.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      }
    } else if (selectedValue == 'Sort by') {
      sortingFilter = tempFilter;
      return sortingFilter;
    }
    return sortingFilter;
  }
  sortingInternal(
    tempFilter: FlightSchedulesNew[],
    sortingFilter: FlightSchedulesNew[]
  ): FlightSchedulesNew[] {
    //sort by
    var ele = document.getElementById('filterSort') as HTMLSelectElement;
    let selectedValue = ele.options[ele.selectedIndex].value;
    if (selectedValue != 'Sort by') {
      if (selectedValue == 'lowestPrice') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.departureFlight.agencyTotalPrice.slice(3)) -
            parseFloat(b.departureFlight.agencyTotalPrice.slice(3))
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'highestPrice') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.departureFlight.agencyTotalPrice.slice(3)) -
            parseFloat(a.departureFlight.agencyTotalPrice.slice(3))
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'shortestDuration') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.departureFlight.elapsedTime) -
            parseFloat(b.departureFlight.elapsedTime)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'highestDuration') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.departureFlight.elapsedTime) -
            parseFloat(a.departureFlight.elapsedTime)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'earliestDeparture') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.departureFlight.departure.time) -
            parseFloat(b.departureFlight.departure.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'latestDeparture') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.departureFlight.departure.time) -
            parseFloat(a.departureFlight.departure.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'earliestArrival') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(a.departureFlight.arrival.time) -
            parseFloat(b.departureFlight.arrival.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      } else if (selectedValue == 'latestArrival') {
        var sortedList = tempFilter.sort(
          (a, b) =>
            parseFloat(b.departureFlight.arrival.time) -
            parseFloat(a.departureFlight.arrival.time)
        );
        sortingFilter = sortingFilter.concat(sortedList);
      }
    } else if (selectedValue == 'Sort by') {
      sortingFilter = tempFilter;
      return sortingFilter;
    }
    return sortingFilter;
  }

  getFareTypeSummaries(flightList: FlightSchedulesNew[]): FaretypeFilters {
    return flightList.reduce((acc, flight) => {
      if (flight.departureFlight.nonRefundable) {
        acc.nonRefundableCountFlights++;
      } else {
        acc.refundableCountFlights++;
      }
      return acc;
    }, new FaretypeFilters());
  }
  getFareTypeSummariesMul(flightList: FlightSchedulesNew[]): FaretypeFilters {
    return flightList.reduce((acc, flight) => {
      if (flight.multiFlights[0].nonRefundable) {
        acc.nonRefundableCountFlights++;
      } else {
        acc.refundableCountFlights++;
      }
      return acc;
    }, new FaretypeFilters());
  }
  getStopsDetailsSummariesMul(flightList: FlightSchedulesNew[]): StopFlightFilters[] {
    return flightList.reduce((acc, flight) => {
      const stopsCount = flight.multiFlights[0].stopCount;

      if (acc.length === 0) {
        acc.push(new StopFlightFilters());
      }

      const stopDetails = acc[0];

      if (stopsCount === 0) {
        stopDetails.directFlights++;
      } else if (stopsCount === 1) {
        stopDetails.oneStopFlights++;
      } else if (stopsCount >= 2) {
        stopDetails.twoStopPlusFlights++;
      }

      return acc;
    }, [] as StopFlightFilters[]);
  }
  getStopsDetailsSummaries(flightList: FlightSchedulesNew[]): StopFlightFilters[] {
    return flightList.reduce((acc, flight) => {
      const stopsCount = flight.departureFlight.stopCount;

      if (acc.length === 0) {
        acc.push(new StopFlightFilters());
      }

      const stopDetails = acc[0];

      if (stopsCount === 0) {
        stopDetails.directFlights++;
      } else if (stopsCount === 1) {
        stopDetails.oneStopFlights++;
      } else if (stopsCount >= 2) {
        stopDetails.twoStopPlusFlights++;
      }

      return acc;
    }, [] as StopFlightFilters[]);
  }
  getReturnStopsDetailsSummaries(flightList: FlightSchedulesNew[]): StopFlightFilters[] {
    return flightList.reduce((acc, flight) => {
      const stopsCount = flight.returnFlight.stopCount;

      if (acc.length === 0) {
        acc.push(new StopFlightFilters());
      }

      const stopDetails = acc[0];

      if (stopsCount === 0) {
        stopDetails.returnDirectFlights++;
      } else if (stopsCount === 1) {
        stopDetails.returnOneStopFlights++;
      } else if (stopsCount >= 2) {
        stopDetails.returnTwoStopFlights++;
      }

      return acc;
    }, [] as StopFlightFilters[]);
  }

  getAirlineFareSummaries(flightList: FlightSchedulesNew[]): FilterByAirlineProperties[] {
    return Object.values(
      flightList.reduce((acc, flight) => {
        if (!acc[flight.departureFlight.airlineLegalName]) {
          acc[flight.departureFlight.airlineLegalName] = {
            airlineName: flight.departureFlight.airlineLegalName,
            airlineLogo: flight.departureFlight.airlineLogo,
            airlineChecked: false,
            airlineLowestPrice: Number(flight.departureFlight.agencyTotalPrice.substring(3)),
            airlineHighestPrice: Number(flight.departureFlight.agencyTotalPrice.substring(3)),
          };
        } else {
          acc[flight.departureFlight.airlineLegalName].airlineLowestPrice = Math.min(
            acc[flight.departureFlight.airlineLegalName].airlineLowestPrice,
            Number(flight.departureFlight.agencyTotalPrice.substring(3))
          );
          acc[flight.departureFlight.airlineLegalName].airlineHighestPrice = Math.max(
            acc[flight.departureFlight.airlineLegalName].airlineHighestPrice,
            Number(flight.departureFlight.agencyTotalPrice.substring(3))
          );
        }
        return acc;
      }, {} as { [key: string]: FilterByAirlineProperties })
    );
  }
  getAirlineFareSummariesOfMulticity(flightList: FlightSchedulesNew[]): FilterByAirlineProperties[] {
    return Object.values(
      flightList.reduce((acc, flight) => {
        if (!acc[flight.multiFlights[0].airlineLegalName]) {
          acc[flight.multiFlights[0].airlineLegalName] = {
            airlineName: flight.multiFlights[0].airlineLegalName,
            airlineLogo: flight.multiFlights[0].airlineLogo,
            airlineChecked: false,
            airlineLowestPrice: Number(flight.multiFlights[0].agencyTotalPrice.substring(3)),
            airlineHighestPrice: Number(flight.multiFlights[0].agencyTotalPrice.substring(3)),
          };
        } else {
          acc[flight.multiFlights[0].airlineLegalName].airlineLowestPrice = Math.min(
            acc[flight.multiFlights[0].airlineLegalName].airlineLowestPrice,
            Number(flight.multiFlights[0].agencyTotalPrice.substring(3))
          );
          acc[flight.multiFlights[0].airlineLegalName].airlineHighestPrice = Math.max(
            acc[flight.multiFlights[0].airlineLegalName].airlineHighestPrice,
            Number(flight.multiFlights[0].agencyTotalPrice.substring(3))
          );
        }
        return acc;
      }, {} as { [key: string]: FilterByAirlineProperties })
    );
  }


  //Flight Email

  sendEmails(displayedFlights: FlightSchedulesNew, AgencyData: AgencyMasterProperties, emailObj: EmailItineraryProperties, inculdeAllResults: boolean, searchObj: FlightSearchProperties, AllFlights: FlightSchedulesNew[], activesearch: number): EmailItineraryProperties {
    try {
      const red = parseInt(this.getCssVariableValue('--red-color'), 10);
      const green = parseInt(this.getCssVariableValue('--green-color'), 10);
      const blue = parseInt(this.getCssVariableValue('--blue-color'), 10);

      let firstColorSecond = "#"+ this.rgbToHex(red, green, blue);

      var divElement = document.createElement('div');
      for (let j = 0; j < displayedFlights.passengerFares.length; j++) {

        divElement.innerHTML = `
        <div style="border: 1px solid #0F5D62; padding: 20px; width:75%; margin: auto;">
          <p style="text-align:center;color:black">Note: This is a system generated message. We request you not to reply to this message.</p>



          <div style="display: flex; justify-content: space-between; background-color:#FFFFFF; ">
              <h2 style="color:#000000; font-weight: bold; font-size: 30px; text-align:left; margin-right: auto;">Flight Itinerary</h2>
              <img style="width: 80px; height: 80px; margin-left: auto;" src="https://scx1.b-cdn.net/csz/news/800/2017/theoreticala.jpg" alt="Image not loaded" />
              </div>
         <hr width="100%" color="black">



          <p style="padding-left: 10px; font-size: 20px; margin-bottom: 8px;color:black"> Dear <b><span style="color:${firstColorSecond};">${emailObj.customerName}</span></b>,</p>
          <p style="padding-left:20px; font-size: 16px; margin-top: 4px;color:black"> &emsp; &emsp; &emsp; "We are pleased to send you the requested itinerary".</p>


${displayedFlights.airSegmentsNew.map((ite, index) =>
          `
       
            <div>
        <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px;color:black">
            ${ite.index == 0 ? "Departure Details" : ite.index == 1 ? "Return Details" : ""}
            </h3>
    </div>
    <hr width="100%" style="border-color: grey; margin-top: 4px;">






        <div style = "display: flex;">
        <div style =" width: 200px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; text-align: center;">

        <p style="font-size: 14px; margin-top:2px; background-color: ${firstColorSecond}; color: white;"> Flight No <br> </p>
        <p <b><span style="text-align: centre; font-size: 14px; padding-top: 1px; margin-top:2px;color:black"> ${ite.carrier}${ite.flightNumber} </span></b> </p>

        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Airline <br></p>
        <p <b><span style="text-align: center; font-size: 14px; padding-top: 1px; margin-top:2px;color:black">
        ${ite.flightLegalName}</span></b></p>
        </div>


    <!-- First Row -->
 
        <div style =" width: 210px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Depature Date <br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;color:black" >
        ${ite.departureDate}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Arrival Date <br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;color:black" >${ite.arrivalDate}</span></b>
        </div>



    <!-- Second Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Departure Time <br></p>
        <p <b><span style=" text-align: center; font-size: 14px; background-color: #f0f0f0; margin-top:2px;color:black"> ${ite.departureTime}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Arrival Time  <br></p>
        <p <b><span style="text-align: center; font-size: 14px; background-color: #f0f0f0; margin-top:2px;color:black">${ite.arrivalTime} </span></b> </p>
         </div>


        <!-- Third Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Origin<br></p>
         <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;color:black"> ${ite.origin.code}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Destination<br></p>
        <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;color:black"> ${ite.destination.code}</span></b></p>
        </div>


        <!-- Fourth Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;color:black"> ${ite.origin.terminal ? ite.origin.terminal : 'N/A '}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;color:black"> ${ite.destination.terminal ? ite.destination.terminal : ' N/A '}</span></b></p>
        </div>


        </div>

    `).join('')}

          <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px;color:black ">Fare Details</h3>
          <hr width="100%" style=" margin-top: 4px;">

          <div style = "display: flex;">
          <div style =" width: 100px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; text-align: center; color: gray;"> PAX <br></p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px;">${displayedFlights.passengerFares[j].passengerType == "1" ? "Adult" : displayedFlights.passengerFares[j].passengerType == "2" ? "Child" : displayedFlights.passengerFares[j].passengerType == "3" ? "Infnat" : ""} x ${displayedFlights.passengerFares[j].count}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray; "> Basic Fare <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${displayedFlights.passengerFares[j].agencyBaseFareAmount}
          </span></b>
          </div>
          <div style =" width: 150px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px;  color: gray;"> Service Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${displayedFlights.passengerFares[j].agencyServiceFee ? displayedFlights.passengerFares[j].agencyServiceFee : "-"}
          </span></b>

          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray; "> Discount <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${displayedFlights.passengerFares[j].agencyDiscount ? displayedFlights.passengerFares[j].agencyDiscount : "-"}
          </span></b>
          </div>
          <div style =" width: 140px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center;">
          <p style="font-size: 14px; margin-top: 2px; color: gray;"> Tax & Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${displayedFlights.passengerFares[j].agencyTaxAmount}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray;"> Total <br> </p><hr width="100%" hight="1px" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${displayedFlights.passengerFares[j].agencyTotalPrice}
          </span></b>
          </div>
          </div>

        <hr>
        <div style =" width: 260px; height: 30px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; margin-left: auto; ">
          <p style="font-size:16px;font-weight:600;margin-top:5px;text-align:right; padding-bottom: 5px;color:black">  Total Net Fare:
         <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 16px; "> ${displayedFlights.departureFlight.agencyTotalPrice}</span></b></p>
          </div>


      <div style="padding-left:10px;margin-top:20px;color:black">For More Information or Assistance Please Call Us!<br><b  style="font-size:10px;margin-top:20px;t">Phone:</b> ${AgencyData.telephoneNumber}    <b>Email:</b>${AgencyData.emailAddress} </div>
      </div>
           
`;

      }
      if (inculdeAllResults == false && activesearch == 1) {



        emailObj.subject = displayedFlights.departureFlight.departure.city + " - " + displayedFlights.departureFlight.arrival.city + "( " + displayedFlights.departureFlight.departure.date + " )" + " :  Requested Flight Itinerary";


        emailObj.body = `

      <div style="border: 0px solid #0F5D62; padding-left: 150px;  padding-right: 150px;">
      ${divElement.innerHTML}
      </div>
`;

      }
      else if (inculdeAllResults == true && activesearch == 1) {
        let flightDataEmail: FlightSchedulesNew[] = JSON.parse(JSON.stringify(AllFlights));
        emailObj.subject = ` ${flightDataEmail[0].departureFlight.departure.city} - ${flightDataEmail[0].departureFlight.arrival.city} (${flightDataEmail[0].departureFlight.departure.date}) : Requested Flight Itinerary `;

        var element = document.createElement('div');
        element.style.padding = "25px";



        for (let j = 0; j < displayedFlights.passengerFares.length; j++) {
          element.innerHTML = `
        <div style="border: 1px solid #0F5D62; padding: 20px; width:75%; margin: auto;">
          <p style="text-align:center">Note: This is a system generated message. We request you not to reply to this message.</p>



          <div style="display: flex; justify-content: space-between; background-color:#FFFFFF; ">
              <h2 style="color:#000000; font-weight: bold; font-size: 30px; text-align:left; margin-right: auto;">Flight Itinerary</h2>
              <img style="width: 80px; height: 80px; margin-left: auto;" src="https://scx1.b-cdn.net/csz/news/800/2017/theoreticala.jpg" alt="Image not loaded" />
              </div>
         <hr width="100%" color="black">



          <p style="padding-left: 10px; font-size: 20px; margin-bottom: 8px;"> Dear <b><span style="color: ${firstColorSecond};">${emailObj.customerName}</span></b>,</p>
          <p style="padding-left:20px; font-size: 16px; margin-top: 4px;"> &emsp; &emsp; &emsp; "We are pleased to send you the requested itinerary".</p>
         
        ${flightDataEmail.map((item) => `

        ${item.airSegmentsNew.map((subItem, index) => `

        <div>
       <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px;">
       Departure Details
            </h3>
       </div>

         <hr width="100%" style="border-color: grey; margin-top: 4px;">


        <div style = "display: flex;">
        <div style =" width: 200px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; text-align: center;">

        <p style="font-size: 14px; margin-top:2px; background-color: ${firstColorSecond}; color: white;"> Flight No <br></p>
        <p b><span style="text-align: centre; font-size: 14px; padding-top: 1px; margin-top: 2px;"> ${subItem.carrier}${subItem.flightNumber} </span></b> </p>

        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Arline <br></p>
        <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;" >
        ${flightDataEmail[index].departureFlight.airlineLegalName}
        </span></b></p>
        </div>




    <!-- First Row -->
    <div style = " width: 210px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Depature Date <br></p>
        <p <b><span style="text-align: center; font-size: 14px; padding-top: 1px; margin-top: 2px;">${subItem.departureDate} </span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Arrival Date <br></p>
        <p <b><span style="text-align: center; font-size: 14px; padding-top: 1px; margin-top: 2px;">${subItem.arrivalDate} </span></b></p>
        </div>


    <!-- Second Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Departure Time <br></p>
         <p <b><span style=" text-align: center; font-size: 14px; background-color: #f0f0f0; margin-top: 2px;">${subItem.departureTime}</span></b></p>
         <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Arrival Time  <br></p>
         <p <b><span style=" text-align: center; font-size: 14px; background-color: #f0f0f0; margin-top: 2px;"> ${subItem.arrivalTime}</span></b> </p>
         </div>


        <!-- Third Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Origin<br></p>
         <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.origin.code}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Destination<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.destination.code}</span></b></p>
        </div>


     
         <!-- Fourth Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.origin.terminal ? subItem.origin.terminal : "N/A"}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.destination.terminal ? subItem.destination.terminal : "N/A"}</span></b></p>
        </div>

 
        </div>

    `).join('')}


          <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px; ">Fare Details</h3>
          <hr width="100%" style=" margin-top: 4px;">

          <div style = "display: flex;">
          <div style =" width: 100px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; text-align: center; color: gray;"> PAX <br></p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px;">${item.passengerFares[j].passengerType == "1" ? "Adult" : item.passengerFares[j].passengerType == "2" ? "Child" : item.passengerFares[j].passengerType == "3" ? "Infnat" : ""} x ${item.passengerFares[j].count}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray; "> Basic Fare <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyBaseFareAmount}
          </span></b>
          </div>
          <div style =" width: 150px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px;  color: gray;"> Service Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyServiceFee ? item.passengerFares[j].agencyServiceFee : "-"}
          </span></b>

          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray; "> Discount <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyDiscount ? item.passengerFares[j].agencyDiscount : "-"}
          </span></b>
          </div>
          <div style =" width: 140px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center;">
          <p style="font-size: 14px; margin-top: 2px; color: gray;"> Tax & Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyTaxAmount}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray;"> Total <br> </p><hr width="100%" hight="1px" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyTotalPrice}
          </span></b>
          </div>
          </div>

        <hr>
        <div style =" width: 260px; height: 30px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; margin-left: auto; ">
          <p style="font-size:16px;font-weight:600;margin-top:5px;text-align:right; padding-bottom: 5px;">  Total Net Fare:
         <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 16px; "> ${item.departureFlight.agencyTotalPrice}</span></b></p>
          </div>
          <br>
        <hr width="100%" style="margin-top: 4px; font-weight: bold;">


        `).join('')}
      `;
        }

        emailObj.body = `
            <div style="border: 0px solid #0F5D62; padding-left: 150px;  padding-right: 150px;">
                 ${element.innerHTML}
       <div style="padding-left:20px;margin-top:20px">For More Information or Assistance Please Call Us!<br><b  style="font-size:10px;margin-top:20px;t">Phone:</b> ${AgencyData.telephoneNumber}    <b>Email:</b>${AgencyData.emailAddress} </div>
       </div>
      `;


      }
      else if (inculdeAllResults == false && activesearch == 2) {

        emailObj.subject = displayedFlights.departureFlight.departure.city + " - " + displayedFlights.departureFlight.arrival.city + "( " + displayedFlights.departureFlight.departure.date + " )" + " :  Requested Flight Itinerary";


        emailObj.body = `

      <div style="border: 0px solid #0F5D62; padding-left: 150px;  padding-right: 150px;">
      ${divElement.innerHTML}
      </div>
`;


      }
      else if (inculdeAllResults == true && activesearch == 2) {
        let RoundFlightArray: FlightSchedulesNew[] = JSON.parse(JSON.stringify(AllFlights));






        emailObj.subject = ` ${RoundFlightArray[0].departureFlight.departure.city} - ${RoundFlightArray[0].departureFlight.arrival.city} (${RoundFlightArray[0].departureFlight.departure.date}) : Requested Flight Itineraries `;

        var element = document.createElement('div');
        element.style.padding = "25px";

        for (let j = 0; j < displayedFlights.passengerFares.length; j++) {
          element.innerHTML = `
        <div style="border: 1px solid #0F5D62; padding: 20px; width:75%; margin: auto;">
          <p style="text-align:center">Note: This is a system generated message. We request you not to reply to this message.</p>



          <div style="display: flex; justify-content: space-between; background-color:#FFFFFF; ">
              <h2 style="color:#000000; font-weight: bold; font-size: 30px; text-align:left; margin-right: auto;">Flight Itinerary</h2>
              <img style="width: 80px; height: 80px; margin-left: auto;" src="https://scx1.b-cdn.net/csz/news/800/2017/theoreticala.jpg" alt="Image not loaded" />
              </div>
         <hr width="100%" color="black">



          <p style="padding-left: 10px; font-size: 20px; margin-bottom: 8px;"> Dear <b><span style="color: ${firstColorSecond};">${emailObj.customerName}</span></b>,</p>
          <p style="padding-left:20px; font-size: 16px; margin-top: 4px;"> &emsp; &emsp; &emsp; "We are pleased to send you the requested itinerary".</p>

 

 
        ${RoundFlightArray.map((item) => `
        ${item.airSegmentsNew.map((subItem, index) =>

            `

        <div>
        <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px;">
        ${subItem.index == 0 ? "Departure Details" : subItem.index == 1 ? "Return Details" : ""}
        </h3>
        </div>

         <hr width="100%" style="border-color: grey; margin-top: 4px;">


        <div style = "display: flex;">

        <div style =" width: 200px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; text-align: center;">

        <p style="font-size: 14px; margin-top:2px; background-color: ${firstColorSecond}; color: white;"> Flight No <br></p>
        <p <b><span style="text-align: centre; font-size: 14px; padding-top: 1px; margin-top: 2px;"> ${subItem.carrier}${subItem.flightNumber} </span></b> </p>

        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Arline <br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;" >
        ${RoundFlightArray[index].departureFlight.airlineLegalName}
        </span></b></p>
        </div>





    <!-- First Row -->
       
        <div style ="width: 210px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Depature Date <br></p>
        <p <b><span style="text-align: center; font-size: 14px; padding-top: 1px; margin-top: 2px;">${subItem.departureDate} </span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Arrival Date <br></p>
        <p <b><span style="text-align: center; font-size: 14px; padding-top: 1px; margin-top: 2px;">${subItem.arrivalDate} </span></b></p>
        </div>


    <!-- Second Row -->
        <div style=" width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Departure Time <br></p>
          <p <b><span style="text-align: center; font-size: 14px; background-color: #f0f0f0; margin-top: 2px;"> ${subItem.departureTime}</span></b></p>
          <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Arrival Time  <br></p>
          <p <b><span style="text-align: center; font-size: 14px; background-color: #f0f0f0; margin-top: 2px;">  ${subItem.arrivalTime}</span></b> </p>
         </div>


        <!-- Third Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px;background-color: ${firstColorSecond}; color: white;">Origin<br></p>
         <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.origin.code}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Destination<br></p>
        <p <b><span style="text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.destination.code}</span></b></p>
        </div>


        <!-- Fourth Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.origin.terminal ? subItem.origin.terminal : "N/A"}</span></b></p>
        <p style="font-size: 14px; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; margin-top: 2px;"> ${subItem.destination.terminal ? subItem.destination.terminal : "N/A"}</span></b></p>
        </div>


        </div>

    `).join('')}

           <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px; ">Fare Details</h3>
          <hr width="100%" style=" margin-top: 4px;">

          <div style = "display: flex;">
          <div style =" width: 100px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; text-align: center; color: gray;"> PAX <br></p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px;">${item.passengerFares[j].passengerType == "1" ? "Adult" : item.passengerFares[j].passengerType == "2" ? "Child" : item.passengerFares[j].passengerType == "3" ? "Infnat" : ""} x ${item.passengerFares[j].count}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray; "> Basic Fare <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyBaseFareAmount}
          </span></b>
          </div>
          <div style =" width: 150px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px;  color: gray;"> Service Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyServiceFee ? item.passengerFares[j].agencyServiceFee : "-"}
          </span></b>

          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray; "> Discount <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyDiscount ? item.passengerFares[j].agencyDiscount : "-"}
          </span></b>
          </div>
          <div style =" width: 140px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center;">
          <p style="font-size: 14px; margin-top: 2px; color: gray;"> Tax & Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyTaxAmount}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="font-size: 14px; margin-top: 2px; color: gray;"> Total <br> </p><hr width="100%" hight="1px" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${item.passengerFares[j].agencyTotalPrice}
          </span></b>
          </div>
          </div>

        <hr>
        <div style =" width: 260px; height: 30px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; margin-left: auto; ">
          <p style="font-size:16px;font-weight:600;margin-top:5px;text-align:right; padding-bottom: 5px;">  Total Net Fare:
         <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 16px; "> ${item.departureFlight.agencyTotalPrice}</span></b></p>
          </div>
          <br>
        <hr width="100%" style="margin-top: 4px; font-weight: bold;">


        `).join('')}
      `;
        }


        emailObj.body = `
               
            <div style="border: 0px solid #0F5D62; padding-left: 150px;  padding-right: 150px;">
                 ${element.innerHTML}
                   <div style="padding-left:20px;margin-top:20px">For More Information or Assistance Please Call Us!<br><b  style="font-size:10px;margin-top:20px;t">Phone:</b> ${AgencyData.telephoneNumber}    <b>Email:</b>${AgencyData.emailAddress} </div>
            </div>
                   `;

      }
    }
    catch (e) {
      console.log(e);
      emailObj.body = null;
    }
    return emailObj;
  }

  getCssVariableValue(variableName: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  }
  rgbToHex(r: number, g: number, b: number): string {
    const toHex = (component: number): string => {
      const hex = component.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };

    return  toHex(r) + toHex(g) + toHex(b);
  }
  sendEmailMulticity1(indexcheck: number, AgencyData: AgencyMasterProperties, emailObj: EmailItineraryProperties, inculdeAllResults: boolean, searchObj: FlightSearchProperties, AllFlights: FlightSchedulesNew[], activesearch: number): EmailItineraryProperties {
    try {

      const red = parseInt(this.getCssVariableValue('--red-color'), 10);
      const green = parseInt(this.getCssVariableValue('--green-color'), 10);
      const blue = parseInt(this.getCssVariableValue('--blue-color'), 10);

      let firstColorSecond = this.rgbToHex(red, green, blue);

      const r = parseInt(firstColorSecond.substring(0, 2), 16);
      const g = parseInt(firstColorSecond.substring(2, 4), 16);
      const b = parseInt(firstColorSecond.substring(4, 6), 16);

  
      var divElement = document.createElement('div');
      var phone = AgencyData.telephoneNumber;
      var email = AgencyData.emailAddress;
      for (let i = indexcheck; i < AllFlights.length; i++) {

        for (let j = 0; j < AllFlights[i].passengerFares.length; j++) {

          divElement.innerHTML = `
        <div style="border: 1px solid #0F5D62; padding: 20px; width:75%; margin: auto;">
          <p style="text-align:center">Note: This is a system generated message. We request you not to reply to this message.</p>



          <div style="display: flex; justify-content: space-between; background-color:#FFFFFF; ">
              <h2 style="color:#000000; font-weight: bold; font-size: 30px; text-align:left; margin-right: auto;">Flight Itinerary</h2>
              <img style="width: 80px; height: 80px; margin-left: auto;" src="https://scx1.b-cdn.net/csz/news/800/2017/theoreticala.jpg" alt="Image not loaded" />
              </div>
         <hr width="100%" color="black">



          <p style="padding-left: 10px; font-size: 20px; margin-bottom: 8px;"> Dear <b><span style="color: ${firstColorSecond};">${emailObj.customerName}</span></b>,</p>
          <p style="padding-left:20px; font-size: 14px; margin-top: 4px;"> &emsp; &emsp; &emsp; "We are pleased to send you the requested itinerary".</p>


${AllFlights[i].airSegmentsNew.map((ite, index) =>
            `
       
            <div>
            <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px;">
           Departure Details
            </h3>
            </div>
    <hr width="100%" style="border-color: grey; margin-top: 4px;">






        <div style = "display: flex;">
        <div style =" width: 200px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; text-align: center;">

        <p style="padding-left:5px; font-size: 16px; font-weight: bold; margin-top:2px; background-color: ${firstColorSecond}; color: white;"> Flight No <br> </p>
        <p <b><span style="text-align: centre; font-size: 14px; padding-top: 1px; font-weight: bold; margin-top:2px;"> ${ite.carrier}${ite.flightNumber} </span></b> </p>

        <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Airline <br></p>
        <p <b><span style="text-align: center; font-size: 14px; padding-top: 1px; font-weight: bold; margin-top:2px;">${ite.flightLegalName} </span></b></p>
        </div>


    <!-- First Row -->
        <div style =" width: 230px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Departure <br></p>
        <p <b><span style=" text-align: center; font-size: 14px; background-color: #f0f0f0; font-weight: bold; margin-top:2px;"> ${new Date(ite.departureDate).toLocaleDateString("en-US", { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })}</span></b></p>
        <p style="font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Arrival  <br></p>
        <p <b><span style="text-align: center; font-size: 14px; background-color: #f0f0f0; font-weight: bold; margin-top:2px;"> ${new Date(ite.arrivalDate).toLocaleDateString("en-US", { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })}</span></b> </p>
        </div>


    <!-- Second Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
         <p style="font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;"> Origin<br></p>
         <p <b><span style="text-align: center; font-size: 14px; font-weight: bold; margin-top: 2px;"> ${ite.origin.code}</span></b></p>
        <p style="font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Destination<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; font-weight: bold; margin-top: 2px;"> ${ite.destination.code}</span></b></p>
         </div>


        <!-- Third Row -->
        <div style="width: 200px; background-color: #f0f0f0; border: 1px solid #fff; padding: 5px; text-align: center;">
        <p style="font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; font-weight: bold; margin-top: 2px;"> ${ite.origin.terminal ? ite.origin.terminal : 'N/A'}</span></b></p>
        <p style="font-size: 16px; font-weight: bold; margin-top: 2px; background-color: ${firstColorSecond}; color: white;">Terminal<br></p>
        <p <b><span style=" text-align: center; font-size: 14px; font-weight: bold; margin-top: 2px;"> ${ite.destination.terminal ? ite.destination.terminal : 'N/A'}</span></b></p>
        </div>

 
        </div>

    `).join('')}

          <h3 style="padding-left: 5px; font-size: 20px; font-weight: bold; margin-bottom: 0px; ">Fare Details</h3>
          <hr width="100%" style=" margin-top: 4px;">

          <div style = "display: flex;">
          <div style =" width: 100px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px; text-align: center; color: gray;"> PAX <br></p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px;">${AllFlights[i].passengerFares[j].passengerType} x ${AllFlights[i].passengerFares[j].count}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px; color: gray; "> Basic Fare <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${AllFlights[i].passengerFares[j].agencyBaseFareAmount}
          </span></b>
          </div>
          <div style =" width: 150px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px;  color: gray;"> Service Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${AllFlights[i].passengerFares[j].agencyServiceFee ? AllFlights[i].passengerFares[j].agencyServiceFee : "-"}
          </span></b>

          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px; color: gray; "> Discount <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${AllFlights[i].passengerFares[j].agencyDiscount ? AllFlights[i].passengerFares[j].agencyDiscount : "-"}
          </span></b>
          </div>
          <div style =" width: 140px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center;">
          <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px; color: gray;"> Tax & Charges <br> </p><hr width="100%" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${AllFlights[i].passengerFares[j].agencyTaxAmount}
          </span></b>
          </div>
          <div style =" width: 120px; height: 70px;  border: 1px solid #fff; padding: 5px; text-align: center; ">
          <p style="padding-left: 5px; font-size: 16px; font-weight: bold; margin-top: 2px; color: gray;"> Total <br> </p><hr width="100%" hight="1px" style=" margin-top: 1px;">
          <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 14px; ">${AllFlights[i].passengerFares[j].agencyTotalPrice}
          </span></b>
          </div>
          </div>

        <hr>
        <div style =" width: 280px; height: 30px;  border: 1px solid #fff; padding: 5px; background-color: #f0f0f0; margin-left: auto; ">
          <p style="font-size:18px;font-weight:600;margin-top:5px;text-align:right; padding-bottom: 5px;">  Total Net Fare:
         <b><span style="color: ${firstColorSecond}; text-align: center; font-size: 18px; "> ${AllFlights[i].multiFlights[j].agencyTotalPrice}</span></b></p>
          </div>

   
      <div style="padding-left:10px;margin-top:20px">For More Information or Assistance Please Call Us!<br><b  style="font-size:10px;margin-top:20px;t">Phone:</b> ${phone}    <b>Email:</b>${email} </div>
      </div>
            
`;

        }
        if (!inculdeAllResults) {
          break;
        }
      }
      /******* MultiCity: Single Card ********/
      if (searchObj.tripType == "multi") {
        emailObj.subject = ` ${searchObj.flightLocationInfo[0].fromCity} - ${searchObj.flightLocationInfo[searchObj.flightLocationInfo.length - 1].toCity} (${AllFlights[0].multiFlights[0].departure.date}) : Requested Flight Itinerary `;

        emailObj.body = `

      <div style="border: 0px solid #0F5D62; padding-left: 150px;  padding-right: 150px;">
      ${divElement.innerHTML}
      </div>
`;

      }
    }
    catch (e) {
      console.log(e);
      emailObj.body = null;
    }
    return emailObj;
  }

  async ReturnPrintClick(displayedFlights: FlightSchedulesNew, AgencyData: AgencyMasterProperties, emailObj: EmailItineraryProperties, inculdeAllResults: boolean, searchObj: FlightSearchProperties, AllFlights: FlightSchedulesNew[], activesearch: number) {

    let x: number;
    let x1: number;
    let x2: number;
    let x3: number;
    let x1ser: number;
    let x1dis: number;
    let jjt1: number;
    let kkt1: number;
    let jjt2: number;
    let kkt2: number;

    let aa1: number;
    let aa2: number;
    let bb1: number;
    let bb2: number;
    let cc1: number;
    let cc2: number;
    let dd1: number;
    let dd2: number;
    let ee1: number;
    let ee2: number;
    let ff1: number;
    let ff2: number;
    let gg1: number;
    let gg2: number;
    let hh1: number;
    let hh2: number;
    let ii1: number;
    let ii2: number;
    let jj1: number;
    let jj2: number;
    let kk1: number;
    let kk2: number;
    let ll1: number;
    let ll2: number;
    let mm1: number;
    let mm2: number;
    let nn1: number;
    let nn2: number;
    let oo1: number;
    let oo2: number;
    let pp1: number;
    let pp2: number;
    let qq2: number;

    try {
      let agencyLogo = AgencyData.logoFileName.split(".");
      let PictureType = agencyLogo[agencyLogo.length - 1];
      var imageString = 'data:image/' + PictureType + ';base64,' + AgencyData.logoFilePath;
      const doc = new jsPDF("p", "mm", "a4");
      let pageHeight = doc.internal.pageSize.height;

      doc.addFileToVFS('Poppins-Regular-normal.ttf', fontEnvironment.font);
      doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
      doc.setFont('Poppins-Regular-normal');
      doc.setFont('Poppins-Regular-normal');
      doc.text(AgencyData.agencyName, 5, 30);
      doc.addImage(imageString, PictureType, 4, 8, 16, 16);
      doc.setFontSize(14);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text(AgencyData.agencyName, 70, 10);
      doc.setFontSize(12);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(AgencyData.country + " ," + AgencyData.city, 70, 17);
      doc.setFontSize(12);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text("PH NO:" + AgencyData.telephoneNumber, 70, 25);
      doc.setFontSize(12);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Email:" + AgencyData.emailAddress, 70, 31);
      doc.setDrawColor(255, 170, 0);
      doc.setFillColor(255, 170, 0);
      doc.rect(5, 35, 200, 8, 'F');
      doc.setFontSize(13);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Itinerary Details", 90, 40);
      doc.setFontSize(14);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Flight Details (Onward) : ", 5, 50);
      doc.setDrawColor(255, 170, 0);
      doc.setFillColor(255, 170, 0);
      doc.rect(5, 52, 200, 7, 'F');
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Airline", 10, 57);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Departure", 45, 57);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Arrival", 90, 57);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Duration", 130, 57);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Baggage", 160, 57);
      //main
      let a1 = 13;
      let a2 = 60;
      let b1 = 45;
      let b2 = 66;
      let c1 = 90;
      let c2 = 66;
      let d1 = 130;
      let d2 = 66;
      let e1 = 160;
      let e2 = 66;
      let f1 = 10;
      let f2 = 72;
      let g1 = 45;
      let g2 = 72;
      let h1 = 90;
      let h2 = 72;
      let i1 = 10;
      let i2 = 77;
      let j1 = 45;
      let jtt1 = 45;
      let j2 = 77;
      let jtt2 = 82;
      let k1 = 90;
      let ktt1 = 90;
      let k2 = 77;
      let ktt2 = 82;
      let l1 = 10;
      let l2 = 84;
      let m1 = 10;
      let m2 = 90;
      let n1 = 7;
      let n2 = 96;
      let o1 = 17;
      let o2 = 96;
      let p1 = 23;
      let p2 = 96;
      let q2 = 96;
      let fromCityCheck = "";
      let returnCityCheck = "";
      if (searchObj.nearByAirport == true) {

        let splitOriginOneWay: string[] = [];
        let splitDestinationOneWay: string[] = [];
        splitOriginOneWay = searchObj.flightLocationInfo[0].combineAirportFrom.split(',');
        splitDestinationOneWay = searchObj.flightLocationInfo[0].combineAirportTo.split(',');
        let splitOriginReturn: string[] = [];
        let splitDestinationReturn: string[] = [];
        splitOriginReturn = searchObj.flightLocationInfo[1].combineAirportFrom.split(',');
        splitDestinationReturn = searchObj.flightLocationInfo[1].combineAirportTo.split(',');
        for (let i = 0; i < searchObj.flightLocationInfo.length; i++) {
          for (let od1 = 0; od1 < splitOriginOneWay.length; od1++) {
            if (splitOriginOneWay[od1] === displayedFlights.airSegmentsNew[i].origin.code) {
              fromCityCheck = displayedFlights.airSegmentsNew[i].origin.code;
              break;
            }
          }
          for (let od1 = 0; od1 < splitOriginReturn.length; od1++) {
            if (splitOriginReturn[od1] === displayedFlights.airSegmentsNew[i].origin.code) {
              returnCityCheck = displayedFlights.airSegmentsNew[i].origin.code;
              break;
            }
          }
        }
      }
      else {

        for (let d = 0; d < displayedFlights.airSegmentsNew.length; d++) {
          if (searchObj.flightLocationInfo[0].fromCity.trim() === displayedFlights.airSegmentsNew[d].origin.code) {
            fromCityCheck = displayedFlights.airSegmentsNew[d].origin.code;
          }
          if (searchObj.flightLocationInfo[1].fromCity.trim() === displayedFlights.airSegmentsNew[d].destination.code) {
            returnCityCheck = displayedFlights.airSegmentsNew[d].destination.code;
          }
        }
      }
      let departureSegments = [];
      let returnSegments = [];
      let isReturnSegment = false;

      for (let dl = 0; dl < displayedFlights.airSegmentsNew.length; dl++) {
        let segment = displayedFlights.airSegmentsNew[dl];

        if (!isReturnSegment) {
          if (segment.origin.code != returnCityCheck) {
            departureSegments.push(segment);
          } else {
            isReturnSegment = true;
            returnSegments.push(segment);
          }
        } else {
          returnSegments.push(segment);
        }
      }



      for (let d = 0; d < departureSegments.length; d++) {
        let dd = '../../assets/img/' + departureSegments[d].flightLogo;
        let imgtype = departureSegments[d].flightLogo.slice(-3);
        try {
          if (imgtype == "svg") {
            const canvass = document.createElement('canvas');
            canvass.width = 900;
            canvass.height = 800;
            const ctx = canvass.getContext('2d');
            const v = await Canvg.from(ctx, dd);
            await v.render();
            var immige = canvass.toDataURL("image/png");
            doc.addImage(immige, 'png', a1, a2, 12, 12);

          } else {
            doc.addImage(dd, 'png', a1, a2, 12, 12);

          }
        } catch (error) {
          console.error("Error loading SVG:", error);
          continue;
        }

        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].flightLegalName, f1, f2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].carrier + '' + departureSegments[d].flightNumber, i1, i2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].cabinClass ? departureSegments[d].cabinClass : "", l1, l2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.departureFlight.fareBasis ? displayedFlights.departureFlight.fareBasis : "NAN", m1, m2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].origin.code, b1, b2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].departureTime, g1, g2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].departureDate, j1, j2);
        if (departureSegments[d].origin.terminal != null && departureSegments[d].origin.terminal != undefined && departureSegments[d].origin.terminal != "") {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + departureSegments[d].origin.terminal, jtt1, jtt2);
        }
        else {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + "", jtt1, jtt2);
        }


        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].destination.code, c1, c2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].arrivalTime, h1, h2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].arrivalDate, k1, k2);
        if (departureSegments[d].destination.terminal != null && departureSegments[d].destination.terminal != undefined && departureSegments[d].destination.terminal != "") {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + departureSegments[d].destination.terminal, ktt1, ktt2);
        }
        else {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + "", ktt1, ktt2);
        }
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].flightTime, d1, d2);


        //baggage
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        if (displayedFlights.frontBaggageAllowance != null) {
          if (displayedFlights.frontBaggageAllowance.length > 0) {
            doc.text(displayedFlights.frontBaggageAllowance[0].checkinBaggage, e1, e2);
          }
          else {
            doc.text("0 KG", e1, e2);
          }
        } else {
          doc.text("0 KG", e1, e2);
        }

        doc.setLineWidth(0.4);
        doc.line(5, m2 + 2, 205, m2 + 2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].equipment ? departureSegments[d].equipment : "N/A", n1, n2);
        //vertical line2
        doc.setLineWidth(0.4);
        doc.line(o1 - 2, n2 - 2.5, o1 - 2, n2 + 2.5)
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(departureSegments[d].cabinClass ? departureSegments[d].cabinClass.slice(0, 1) : "", o1, o2);
        //vertical line3
        doc.setLineWidth(0.4);
        doc.line(p1 - 2, o2 - 2.5, p1 - 2, o2 + 2.5)
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.departureFlight.nonRefundable ? "Non Refundable" : "Refundable", p1, q2);
        doc.setLineWidth(0.4);
        doc.line(5, n2 + 2.5, 205, n2 + 2.5);
        a2 = a2 + 44;
        b2 = b2 + 44;
        c2 = c2 + 44;
        d2 = d2 + 44;
        e2 = e2 + 44;
        f2 = f2 + 44;
        g2 = g2 + 44;
        h2 = h2 + 44;
        i2 = i2 + 44;
        j2 = j2 + 44;
        jtt2 = jtt2 + 44;
        k2 = k2 + 44;
        ktt2 = ktt2 + 44;
        l2 = l2 + 44;
        m2 = m2 + 44;
        n2 = n2 + 44;
        o2 = o2 + 44;
        q2 = q2 + 44;
        if (d > 0) {
          p2 += 44;

        }


      }

      aa1 = 13;
      aa2 = p2 + 23;
      bb1 = 45;
      bb2 = p2 + 29;
      cc1 = 90;
      cc2 = p2 + 29;
      dd1 = 130;
      dd2 = p2 + 29;
      ee1 = 160;
      ee2 = p2 + 29;
      ff1 = 10;
      ff2 = p2 + 36;
      gg1 = 45;
      gg2 = p2 + 35;
      hh1 = 90;
      hh2 = p2 + 35;
      ii1 = 10;
      ii2 = p2 + 41;
      jj1 = 45;
      jjt1 = 45;
      jj2 = p2 + 40.5;
      jjt2 = p2 + 45;
      kk1 = 90;
      kkt1 = 90;
      kk2 = p2 + 40.5;
      kkt2 = p2 + 45;
      ll1 = 10;
      ll2 = p2 + 48;
      mm1 = 10;
      mm2 = p2 + 54;
      nn1 = 7;
      nn2 = p2 + 61;
      oo1 = 17;
      oo2 = p2 + 61;
      pp1 = 23;
      pp2 = p2 + 61;
      qq2 = p2 + 61;
      //return static part
      doc.setFontSize(16);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Flight Details (RETURN) :", 7, p2 + 14);
      doc.setDrawColor(255, 170, 0);
      doc.setFillColor(255, 170, 0);
      doc.rect(5, p2 + 16, 200, 7, 'F');
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Airline", 10, p2 + 21);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Departure", 45, p2 + 21);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Arrival", 90, p2 + 21);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Duration", 130, p2 + 21);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Baggage", 160, p2 + 21);
      //return dynamic part

      for (let e = 0; e < returnSegments.length; e++) {

        let dd = '../../assets/img/' + returnSegments[e].flightLogo;
        let imgtype = returnSegments[e].flightLogo.slice(-3);
        try {
          if (imgtype == "svg") {
            const canvass = document.createElement('canvas');
            canvass.width = 900;
            canvass.height = 900;
            const ctx = canvass.getContext('2d');
            const v = await Canvg.from(ctx, dd);
            await v.render();
            var immige = canvass.toDataURL("image/png");
            doc.addImage(immige, 'png', aa1, aa2, 12, 12);

          } else {
            doc.addImage(dd, 'png', aa1, aa2, 12, 12);

          }
        } catch (error) {
          console.error("Error loading SVG:", error);
          continue;
        }

        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].flightLegalName, ff1, ff2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].carrier + '' + returnSegments[e].flightNumber, ii1, ii2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].cabinClass ? returnSegments[e].cabinClass : "", ll1, ll2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.departureFlight.fareBasis ? displayedFlights.departureFlight.fareBasis : "NAN", mm1, mm2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].origin.code, bb1, bb2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].departureTime, gg1, gg2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].departureDate, jj1, jj2);

        if (returnSegments[e].origin.terminal != null && returnSegments[e].origin.terminal != undefined && returnSegments[e].origin.terminal != "") {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + returnSegments[e].origin.terminal, jjt1, jjt2);
        }
        else {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + "", jjt1, jjt2);
        }
        //arrival
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].destination.code, cc1, cc2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].arrivalTime, hh1, hh2);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].arrivalDate, kk1, kk2);

        if (returnSegments[e].destination.terminal != null && returnSegments[e].destination.terminal != undefined && returnSegments[e].destination.terminal != "") {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + returnSegments[e].destination.terminal, kkt1, kkt2);
        }
        else {
          doc.setFontSize(10);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text("Terminal:" + "", kkt1, kkt2);
        }


        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].flightTime, dd1, dd2);


        //baggage
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        if (displayedFlights.frontBaggageAllowance != null) {
          if (displayedFlights.frontBaggageAllowance.length > 0) {
            doc.text(displayedFlights.frontBaggageAllowance[0].checkinBaggage, ee1, ee2);
          }
          else {
            doc.text("0 KG", e1, e2);
          }
        } else {
          doc.text("0 KG", e1, e2);
        }

        doc.setLineWidth(0.4);
        doc.line(5, mm2 + 3, 205, mm2 + 3);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].equipment, nn1, nn2);
        //vertical line2
        doc.setLineWidth(0.4);
        doc.line(oo1 - 2, nn2 - 2.5, oo1 - 2, nn2 + 2.5)
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(returnSegments[e].cabinClass ? returnSegments[e].cabinClass.slice(0, 1) : "", oo1, oo2);
        //line3
        doc.setLineWidth(0.4);
        doc.line(pp1 - 2, oo2 - 2.5, pp1 - 2, oo2 + 2.5)
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.departureFlight.nonRefundable ? "Non Refundable" : "Refundable", pp1, qq2);

        doc.setLineWidth(0.4);
        doc.line(5, nn2 + 2.5, 205, nn2 + 2.5);
        if (pp2 != 289 && pp2 != 44) {
          aa2 = aa2 + 44;
          bb2 = bb2 + 44;
          cc2 = cc2 + 44;
          dd2 = dd2 + 44;
          ee2 = ee2 + 44;
          ff2 = ff2 + 44;
          gg2 = gg2 + 44;
          hh2 = hh2 + 44;
          ii2 = ii2 + 44;
          jj2 = jj2 + 44;
          jjt2 = jjt2 + 44;
          kk2 = kk2 + 44;
          kkt2 = kkt2 + 44;
          ll2 = ll2 + 44;
          mm2 = mm2 + 44;
          nn2 = nn2 + 44;
          if (e == returnSegments.length - 1) {
            oo2 = oo2;
          } else {
            oo2 = oo2 + 44;

          }
          qq2 = qq2 + 44;
        }
        if (e > 0) {
          pp2 += 44;
        }
        if (pp2 == 289) {
          doc.addPage();
          pp2 = 44;
          aa2 = 7;
          bb2 = 13;
          cc2 = 13;
          dd2 = 13;
          ee2 = 13;
          ff2 = 20;
          gg2 = 19;
          hh2 = 19;
          ii2 = 25;
          jj2 = 25;
          jjt2 = 29.3;
          kk2 = 25;
          kkt2 = 29.3;
          ll2 = 32;
          mm2 = 38;
          nn2 = 45;
          if (e == returnSegments.length - 1) {
            oo2 = 0;
          } else {
            oo2 = 45;

          }
          qq2 = 45;
        }
        else if (pp2 == 44) {
          aa2 = aa2 + 44;
          bb2 = bb2 + 44;
          cc2 = cc2 + 44;
          dd2 = dd2 + 44;
          ee2 = ee2 + 44;
          ff2 = ff2 + 44;
          gg2 = gg2 + 44;
          hh2 = hh2 + 44;
          ii2 = ii2 + 44;
          jj2 = jj2 + 44;
          jjt2 = jjt2 + 44;
          kk2 = kk2 + 44;
          kkt2 = kkt2 + 44;
          ll2 = ll2 + 44;
          mm2 = mm2 + 44;
          nn2 = nn2 + 44;
          if (e == returnSegments.length - 1) {
            oo2 = oo2;
          } else {
            oo2 = oo2 + 44;

          }
          qq2 = qq2 + 44;
        }
      }




      //end
      let fSpace = oo2 + 15;
      let baseIs = fSpace + 7;
      doc.setFontSize(14);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Fare Summary:", 5, fSpace);
      var bodyData = [];
      displayedFlights.passengerFares.forEach(items => {
        if (displayedFlights.departureFlight.groupTicketId > 0) {
          items.agencyTaxAmount = items.agencyTaxAmount.substring(0, 3) + (Number(items.agencyTaxAmount.substring(3)) + Number(items.gruoupTicketServiceCharges.substring(3)));
        }
        // Apply condition or any other logic
        let pxtype = "";
        if (items.passengerType == "1") {
          pxtype = "Adult";
        }
        else if (items.passengerType == "2") {
          pxtype = "Child";
        }
        else if (items.passengerType == "3") {
          pxtype = "Infant";
        }
        bodyData.push([pxtype + " (" + items.count + ")", items.agencyBaseFareAmount, items.agencyServiceFee, items.agencyDiscount, items.agencyTaxAmount, items.agencyTotalPrice])
      });
      autoTable(doc, {
        head: [['Passenger Type', 'Base Fare', 'Service Fee', 'Discount', 'Taxes', 'Total Amount']],
        headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
        body: bodyData,
        columnStyles: {
          0: { fontSize: 9, valign: 'middle', textColor: [255, 170, 0], fontStyle: 'bold', halign: 'center' },
          1: { fontSize: 9, valign: 'middle', halign: 'center' },
          2: { fontSize: 9, valign: 'middle', halign: 'center' },
          3: { fontSize: 9, valign: 'middle', halign: 'center' },
          4: { fontSize: 9, valign: 'middle', halign: 'center' },
          5: { fontSize: 9, valign: 'middle', halign: 'center' },
        },
        startY: fSpace + 5,
        theme: 'plain',
      })
      let finalYss = (doc as any).lastAutoTable.finalY;
      let summary = finalYss + 6;
      let r = summary;
      let s = summary;
      let t = summary;
      let u = summary;
      x = 8;
      x1 = 40;
      x1ser = 65;
      x1dis = 95;
      x2 = 130;
      x3 = 180;


      let grossTotal = 0;

      for (let i = 0; i < displayedFlights.passengerFares.length; i++) {
        grossTotal = grossTotal + Number(displayedFlights.passengerFares[i].agencyTotalPrice.slice(3));

      }
      doc.setFontSize(14);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Total Gross Fare:", 110, u + 6);

      doc.setFontSize(14);
      doc.setTextColor('#f5c107');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.passengerFares[0].agencyTotalPrice.slice(0, 3) + String(grossTotal), 160, u + 6);
      grossTotal = 0;
      //border lines
      doc.setLineWidth(0.6);
      doc.setDrawColor(107, 107, 107);
      doc.setFillColor(213, 213, 213);
      doc.setLineDashPattern([0, 0], 0);
      doc.line(1, 1, 1, 295)
      doc.setLineWidth(0.6);
      doc.setDrawColor(107, 107, 107);
      doc.setFillColor(213, 213, 213);
      doc.setLineDashPattern([0, 0], 0);
      doc.line(209, 1, 209, 295);
      doc.setLineWidth(0.6);
      doc.setDrawColor(107, 107, 107);
      doc.setFillColor(213, 213, 213);
      doc.setLineDashPattern([0, 0], 0);
      doc.line(1, 1, 209, 1)
      doc.setLineWidth(0.6);
      doc.setDrawColor(107, 107, 107);
      doc.setFillColor(213, 213, 213);
      doc.setLineDashPattern([0, 0], 0);
      doc.line(1, 295, 209, 295)
      let pdfname = fromCityCheck + "-->" + returnCityCheck + "(Return).pdf";
      doc.save(pdfname);
    } catch (e) { }
  }
  async printClickOneWay(displayedFlights: FlightSchedulesNew, AgencyData: AgencyMasterProperties, emailObj: EmailItineraryProperties, inculdeAllResults: boolean, searchObj: FlightSearchProperties, AllFlights: FlightSchedulesNew[], activesearch: number) {
    let x: number;
    let y: number;
    let x1: number;
    let y1: number;
    let x2: number;
    let y2: number;
    let x3: number;
    let y3: number;
    let x1ser: number;
    let x1dis: number;
    let ktt1: number;
    let ktt2: number;
    let jjt1: number;
    let kkt1: number;
    let jjt2: number;
    let kkt2: number;
    let skt1: number;
    let skt2: number;
    let slt1: number;
    let slt2: number;
    let jt1: number;
    let jt2: number;
    let kt1: number;
    let kt2: number;
    let sa1: number;
    let sa2: number;
    let sb1: number;
    let sb2: number;
    let sc1: number;
    let sc2: number;
    let sd1: number;
    let sd2: number;
    let se1: number;
    let se2: number;
    let sf1: number;
    let sf2: number;
    let sg1: number;
    let sg2: number;
    let sh1: number;
    let sh2: number;
    let si1: number;
    let si2: number;
    let sj1: number;
    let sj2: number;
    let sk1: number;
    let sk2: number;
    let sl1: number;
    let sl2: number;
    let sm1: number;
    let sm2: number;
    let sn1: number;
    let sn2: number;
    let so1: number;
    let so2: number;
    let sp1: number;
    let sp2: number;
    let sq1: number;
    let sq2: number;
    let jtt1: number;
    let jtt2: number;
    let a1: number;
    let a2: number;
    let b1: number;
    let b2: number;
    let c1: number;
    let c2: number;
    let d1: number;
    let d2: number;
    let e1: number;
    let e2: number;
    let f1: number;
    let f2: number;
    let g1: number;
    let g2: number;
    let h1: number;
    let h2: number;
    let i1: number;
    let i2: number;
    let j1: number;
    let j2: number;
    let k1: number;
    let k2: number;
    let l1: number;
    let l2: number;
    let m1: number;
    let m2: number;
    let n1: number;
    let n2: number;
    let o1: number;
    let o2: number;
    let p1: number;
    let p2: number;
    let aa1: number;
    let aa2: number;
    let bb1: number;
    let bb2: number;
    let cc1: number;
    let cc2: number;
    let dd1: number;
    let dd2: number;
    let ee1: number;
    let ee2: number;
    let ff1: number;
    let ff2: number;
    let gg1: number;
    let gg2: number;
    let hh1: number;
    let hh2: number;
    let ii1: number;
    let ii2: number;
    let jj1: number;
    let jj2: number;
    let kk1: number;
    let kk2: number;
    let ll1: number;
    let ll2: number;
    let mm1: number;
    let mm2: number;
    let nn1: number;
    let nn2: number;
    let oo1: number;
    let oo2: number;
    let pp1: number;
    let pp2: number;


    let p2a1: number;
    let p2a2: number;
    let p2b1: number;
    let p2b2: number;
    let p2c1: number;
    let p2c2: number;
    let p2d1: number;
    let p2d2: number;
    let p2e1: number;
    let p2e2: number;
    let p2f1: number;
    let p2f2: number;
    let p2g1: number;
    let p2g2: number;
    let p2h1: number;
    let p2h2: number;
    let p2i1: number;
    let p2i2: number;
    let p2j1: number;
    let p2j2: number;
    let p2k1: number;
    let p2k2: number;
    let p2l1: number;
    let p2l2: number;
    let p2m1: number;
    let p2m2: number;
    let p2n1: number;
    let p2n2: number;
    let p2o1: number;
    let p2o2: number;
    let p2p1: number;
    let p2p2: number;
    let agencyLogo = AgencyData.logoFileName.split(".");
    let PictureType = agencyLogo[agencyLogo.length - 1];
    var imageString = 'data:image/' + PictureType + ';base64,' + AgencyData.logoFilePath;

    const doc = new jsPDF("p", "mm", "a4");
    doc.addFileToVFS('Poppins-Regular-normal.ttf', fontEnvironment.font);
    doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
    doc.setFont('Poppins-Regular-normal');
    doc.setFont('Poppins-Regular-normal');
    doc.text(AgencyData.agencyName, 5, 29);
    doc.addImage(imageString, PictureType, 4, 8, 16, 16);
    doc.setFontSize(14);
    doc.setTextColor('#ffaa00');
    doc.setFont('Poppins-Regular-normal');
    doc.text(AgencyData.agencyName, 70, 10);
    doc.setFontSize(12);
    doc.setTextColor('#111');
    doc.setFont('Poppins-Regular-normal');
    doc.text(AgencyData.country + " ," + AgencyData.city, 70, 17);
    doc.setFontSize(12);
    doc.setTextColor('#111');
    doc.setFont('Poppins-Regular-normal');
    doc.text("PH NO:" + AgencyData.telephoneNumber, 70, 25);
    doc.setFontSize(12);
    doc.setTextColor('#111');
    doc.setFont('Poppins-Regular-normal');
    doc.text("Email:" + AgencyData.emailAddress, 70, 31);
    doc.setDrawColor(255, 170, 0);
    doc.setFillColor(255, 170, 0);
    doc.rect(5, 35, 200, 7, 'F');
    doc.setFontSize(14);
    doc.setTextColor('#fff');
    doc.setFont('Poppins-Regular-normal');
    doc.text("Itinerary Details", 90, 40);
    doc.setFontSize(14);
    doc.setTextColor('#ffaa00');
    doc.setFont('Poppins-Regular-normal');
    doc.text("Flight Details (Onward) : ", 5, 57);
    doc.setDrawColor(255, 170, 0);
    doc.setFillColor(255, 170, 0);
    doc.rect(5, 60, 200, 9, 'F');
    doc.setFontSize(12);
    doc.setTextColor('#fff');
    doc.setFont('Poppins-Regular-normal');
    doc.text("Airline", 10, 66);
    console.log("assets/img/" + displayedFlights.departureFlight.airlineLogo);
    sa1 = 10;
    sa2 = 69;
    sb1 = 50;
    sb2 = 74;
    sc1 = 90;
    sc2 = 74;
    sd1 = 130;
    sd2 = 74;
    se1 = 160;
    se2 = 74;
    sf1 = 20;
    sf2 = 84;
    sg1 = 50;
    sg2 = 80;
    sh1 = 90;
    sh2 = 80;
    si1 = 130;
    si2 = 80;
    sj1 = 10;
    sj2 = 86;
    sk1 = 50;
    sk2 = 86;
    skt1 = 50;
    skt2 = 92;
    sl1 = 90;
    sl2 = 86;
    slt1 = 90;
    slt2 = 92;
    sm1 = 10;
    sm2 = 92;
    sn1 = 10;
    sn2 = 98;
    so1 = 5;
    so2 = 106;
    sp1 = 17;
    sp2 = 106;
    sq1 = 23;
    sq2 = 106;
    for (let d = 0; d < displayedFlights.airSegmentsNew.length; d++) {
      let counter = displayedFlights.airSegmentsNew.length;
      let dd = '../../assets/img/' + displayedFlights.airSegmentsNew[d].flightLogo;
      let imgtype = displayedFlights.airSegmentsNew[d].flightLogo.slice(-3);
      try {
        if (imgtype == "svg") {
          const canvass = document.createElement('canvas');
          canvass.width = 900;
          canvass.height = 900;
          const ctx = canvass.getContext('2d');
          const v = await Canvg.from(ctx, dd);
          await v.render();
          var immige = canvass.toDataURL("image/png");
          console.log(immige);
          doc.addImage(immige, 'png', sa1, sa2, 12, 12);

        } else {
          doc.addImage(dd, 'png', sa1, sa2, 12, 12);

        }
      } catch (error) {
        console.error("Error loading SVG:", error);
        continue;
      }
      //airline
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      let flightlegalname = displayedFlights.airSegmentsNew[d].flightLegalName;
      let flightlegalnumy = sf2;
      doc.text(flightlegalname, 10, flightlegalnumy);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].carrier + '' + displayedFlights.airSegmentsNew[d].flightNumber, sj1, flightlegalnumy + 5);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.departureFlight.cabinClass, sm1, flightlegalnumy + 5 + 4);
      if (displayedFlights.departureFlight.fareBasis != null && displayedFlights.departureFlight.fareBasis != "" && displayedFlights.departureFlight.fareBasis != undefined) {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.departureFlight.fareBasis, sn1, flightlegalnumy + 5 + 4 + 4);
      }
      else {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("", sn1, flightlegalnumy + 5 + 4 + 4);
      }

      //departure
      doc.setFontSize(11);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Departure", 50, 66);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].origin.code, sb1, sb2);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].departureDate, sg1, sg2);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].departureTime, sk1, sk2);

      if (displayedFlights.airSegmentsNew[d].origin.terminal != null && displayedFlights.airSegmentsNew[d].origin.terminal != "" && displayedFlights.airSegmentsNew[d].origin.terminal != undefined) {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Terminal:" + displayedFlights.airSegmentsNew[d].origin.terminal, skt1, skt2);
      }
      else {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Terminal:" + "", skt1, skt2);
      }


      //arrival
      doc.setFontSize(11);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Arrival", 90, 66);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].destination.code, sc1, sc2);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].arrivalDate, sh1, sh2);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].arrivalTime, sl1, sl2);

      if (displayedFlights.airSegmentsNew[d].destination.terminal != null && displayedFlights.airSegmentsNew[d].destination.terminal != "" && displayedFlights.airSegmentsNew[d].destination.terminal != undefined) {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Terminal:" + displayedFlights.airSegmentsNew[d].destination.terminal, slt1, slt2);
      }
      else {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Terminal:" + "", slt1, slt2);
      }


      //duration
      doc.setFontSize(11);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Duration", 130, 66);

      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.airSegmentsNew[d].flightTime, sd1, sd2);
      //baggage
      doc.setFontSize(11);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Baggage", 160, 66);
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.frontBaggageAllowance[0].checkinBaggage, se1, se2);
      //line
      doc.setLineWidth(0.3);
      doc.line(5, so2 - 3.5, 200, so2 - 3.5);
      if (displayedFlights.airSegmentsNew[d].equipment != null && displayedFlights.airSegmentsNew[d].equipment != "" && displayedFlights.airSegmentsNew[d].equipment != undefined) {

        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.airSegmentsNew[d].equipment, so1, so2);
      }
      else {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("", so1, so2);
      }

      doc.setLineWidth(0.5);
      doc.line(15, sp2 - 3, 15, sp2 + 3)
      if (displayedFlights.departureFlight.cabinClass != null && displayedFlights.departureFlight.cabinClass != "" && displayedFlights.departureFlight.cabinClass != undefined) {

        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.departureFlight.cabinClass.slice(0, 1), sp1, sp2);
      }
      else {
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("", sp1, sp2);
      }

      doc.setLineWidth(0.5);
      doc.line(22, sp2 - 3, 22, sp2 + 3)
      doc.setFontSize(11);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(displayedFlights.departureFlight.nonRefundable ? "Non Refundable" : "Refundable", sq1, sq2);
      doc.setLineWidth(0.3);
      doc.line(5, so2 + 3.5, 200, so2 + 3.5);
      if (counter <= d + 1) {
        break;
      }
      sa2 = sa2 + 44;
      sb2 = sb2 + 44;
      sc2 = sc2 + 44;
      sd2 = sd2 + 44;
      se2 = se2 + 44;
      sf2 = sf2 + 44;
      sg2 = sg2 + 44;
      sh2 = sh2 + 44;
      si2 = si2 + 44;
      sj2 = sj2 + 44;
      sk2 = sk2 + 44;
      sl2 = sl2 + 44;
      skt2 = skt2 + 44;
      slt2 = slt2 + 44;
      sm2 = sm2 + 44;
      sn2 = sn2 + 44;
      so2 = so2 + 44;
      sp2 = sp2 + 44;
      sq2 = sq2 + 44;
    }
    let mid = sp2;
    doc.setFontSize(14);
    doc.setTextColor('#ffaa00');
    doc.setFont('Poppins-Regular-normal');
    doc.text("Fare Summary:", 5, mid + 11);
    var bodyData = [];
    displayedFlights.passengerFares.forEach(items => {
      if (displayedFlights.departureFlight.groupTicketId > 0) {
        items.agencyTaxAmount = items.agencyTaxAmount.substring(0, 3) + (Number(items.agencyTaxAmount.substring(3)) + Number(items.gruoupTicketServiceCharges.substring(3)));
      }
      // Apply condition or any other logic
      let pxtype = "";
      if (items.passengerType == "1") {
        pxtype = "Adult";
      }
      else if (items.passengerType == "2") {
        pxtype = "Child";
      }
      else if (items.passengerType == "3") {
        pxtype = "Infant";
      }
      bodyData.push([pxtype + " (" + items.count + ")", items.agencyBaseFareAmount, items.agencyServiceFee, items.agencyDiscount, items.agencyTaxAmount, items.agencyTotalPrice])
    });
    autoTable(doc, {
      head: [['Passenger Type', 'Base Fare', 'Service Fee', 'Discount', 'Taxes', 'Total Amount']],
      headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
      body: bodyData,
      columnStyles: {
        0: { fontSize: 9, valign: 'middle', textColor: [255, 170, 0], fontStyle: 'bold', halign: 'center' },
        1: { fontSize: 9, valign: 'middle', halign: 'center' },
        2: { fontSize: 9, valign: 'middle', halign: 'center' },
        3: { fontSize: 9, valign: 'middle', halign: 'center' },
        4: { fontSize: 9, valign: 'middle', halign: 'center' },
        5: { fontSize: 9, valign: 'middle', halign: 'center' },
      },
      startY: mid + 13,
      theme: 'plain',
    })
    let finalYss = (doc as any).lastAutoTable.finalY;
    let wid = finalYss + 2;
    x = 8;
    y = wid;
    x1 = 40;
    x1ser = 65;
    x1dis = 95;
    y1 = wid;
    x2 = 130;
    y2 = wid;
    x3 = 180;
    y3 = wid;
    let grossTotal = 0;
    for (let i = 0; i < displayedFlights.passengerFares.length; i++) {
      grossTotal = grossTotal + Number(displayedFlights.passengerFares[i].agencyTotalPrice.slice(3));
    }
    doc.setFontSize(12);
    doc.setTextColor('#ffaa00');
    doc.setFont('Poppins-Regular-normal');
    doc.text("Total Gross Fare:", 110, y3 + 6);
    doc.setFontSize(13);
    doc.setTextColor('#ffaa00');
    doc.setFont('Poppins-Regular-normal');
    doc.text(displayedFlights.passengerFares[0].agencyTotalPrice.slice(0, 3) + String(grossTotal.toFixed(2)), 160, y3 + 6);
    doc.setLineWidth(0.6);
    doc.setDrawColor(107, 107, 107);
    doc.setFillColor(213, 213, 213);
    doc.setLineDashPattern([0, 0], 0);
    doc.line(1, 1, 1, 295);
    doc.setLineWidth(0.6);
    doc.setDrawColor(107, 107, 107);
    doc.setFillColor(213, 213, 213);
    doc.setLineDashPattern([0, 0], 0);
    doc.line(209, 1, 209, 295);
    doc.setLineWidth(0.6);
    doc.setDrawColor(107, 107, 107);
    doc.setFillColor(213, 213, 213);
    doc.setLineDashPattern([0, 0], 0);
    doc.line(1, 1, 209, 1);
    doc.setLineWidth(0.6);
    doc.setDrawColor(107, 107, 107);
    doc.setFillColor(213, 213, 213);
    doc.setLineDashPattern([0, 0], 0);
    doc.line(1, 295, 209, 295);
    grossTotal = 0;
    let pdfname = displayedFlights.departureFlight.departure.city + "-->" + displayedFlights.departureFlight.arrival.city + "(Oneway).pdf";
    doc.save(pdfname);
  }

  async printClickMulticity(displayedFlights: FlightSchedulesNew, AgencyData: AgencyMasterProperties, emailObj: EmailItineraryProperties, inculdeAllResults: boolean, searchObj: FlightSearchProperties, AllFlights: FlightSchedulesNew[], activesearch: number) {
    let x: number;
    let y: number;
    let x1: number;
    let y1: number;
    let x2: number;
    let y2: number;
    let x3: number;
    let y3: number;
    let x1ser: number;
    let x1dis: number;
    let ktt1: number;
    let ktt2: number;
    let jjt1: number;
    let kkt1: number;
    let jjt2: number;
    let kkt2: number;
    let skt1: number;
    let skt2: number;
    let slt1: number;
    let slt2: number;
    let jt1: number;
    let jt2: number;
    let kt1: number;
    let kt2: number;
    let sa1: number;
    let sa2: number;
    let sb1: number;
    let sb2: number;
    let sc1: number;
    let sc2: number;
    let sd1: number;
    let sd2: number;
    let se1: number;
    let se2: number;
    let sf1: number;
    let sf2: number;
    let sg1: number;
    let sg2: number;
    let sh1: number;
    let sh2: number;
    let si1: number;
    let si2: number;
    let sj1: number;
    let sj2: number;
    let sk1: number;
    let sk2: number;
    let sl1: number;
    let sl2: number;
    let sm1: number;
    let sm2: number;
    let sn1: number;
    let sn2: number;
    let so1: number;
    let so2: number;
    let sp1: number;
    let sp2: number;
    let sq1: number;
    let sq2: number;
    let jtt1: number;
    let jtt2: number;
    let a1: number;
    let a2: number;
    let b1: number;
    let b2: number;
    let c1: number;
    let c2: number;
    let d1: number;
    let d2: number;
    let e1: number;
    let e2: number;
    let f1: number;
    let f2: number;
    let g1: number;
    let g2: number;
    let h1: number;
    let h2: number;
    let i1: number;
    let i2: number;
    let j1: number;
    let j2: number;
    let k1: number;
    let k2: number;
    let l1: number;
    let l2: number;
    let m1: number;
    let m2: number;
    let n1: number;
    let n2: number;
    let o1: number;
    let o2: number;
    let p1: number;
    let p2: number;
    let aa1: number;
    let aa2: number;
    let bb1: number;
    let bb2: number;
    let cc1: number;
    let cc2: number;
    let dd1: number;
    let dd2: number;
    let ee1: number;
    let ee2: number;
    let ff1: number;
    let ff2: number;
    let gg1: number;
    let gg2: number;
    let hh1: number;
    let hh2: number;
    let ii1: number;
    let ii2: number;
    let jj1: number;
    let jj2: number;
    let kk1: number;
    let kk2: number;
    let ll1: number;
    let ll2: number;
    let mm1: number;
    let mm2: number;
    let nn1: number;
    let nn2: number;
    let oo1: number;
    let oo2: number;
    let pp1: number;
    let pp2: number;


    let p2a1: number;
    let p2a2: number;
    let p2b1: number;
    let p2b2: number;
    let p2c1: number;
    let p2c2: number;
    let p2d1: number;
    let p2d2: number;
    let p2e1: number;
    let p2e2: number;
    let p2f1: number;
    let p2f2: number;
    let p2g1: number;
    let p2g2: number;
    let p2h1: number;
    let p2h2: number;
    let p2i1: number;
    let p2i2: number;
    let p2j1: number;
    let p2j2: number;
    let p2k1: number;
    let p2k2: number;
    let p2l1: number;
    let p2l2: number;
    let p2m1: number;
    let p2m2: number;
    let p2n1: number;
    let p2n2: number;
    let p2o1: number;
    let p2o2: number;
    let p2p1: number;
    let p2p2: number;
    try {
      let cd = [];
      let selectedFlights = [];

      let multiSelectedIndex: number = 0;

      let farePricing: PassengerFares[] = [];
      let pFares = displayedFlights.passengerFares;
      for (let m = 0; m < pFares.length; m++) {
        let pFareObj = new PassengerFares();
        pFareObj.agencyBaseFareAmount = pFares[m].agencyBaseFareAmount;
        pFareObj.count = pFares[m].count;
        if (pFares[m].passengerType == String(1)) {
          pFareObj.passengerType = "Adult";
        }
        else if (pFares[m].passengerType == String(3)) {
          pFareObj.passengerType = "Infant";
        }
        else if (pFares[m].passengerType == String(2)) {
          pFareObj.passengerType = "Child";
        }
        pFareObj.agencyServiceFee = pFares[m].agencyServiceFee;
        pFareObj.agencyTaxAmount = pFares[m].agencyTaxAmount;
        pFareObj.agencyTotalPrice = pFares[m].agencyTotalPrice;
        farePricing.push(pFareObj);
      }
      let PictureType = AgencyData.logoFileName.split(".")[1];
      var imageString = 'data:image/' + PictureType + ';base64,' + AgencyData.logoFilePath;
      const doc = new jsPDF("p", "mm", "a4");
      doc.addFileToVFS('Poppins-Regular-normal.ttf', fontEnvironment.font);
      doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
      doc.setFont('Poppins-Regular-normal');
      doc.setFont('Poppins-Regular-normal');
      doc.text(AgencyData.agencyName, 150, 29);
      doc.addImage(imageString, PictureType, 152, 8, 18, 14);
      doc.setFontSize(14);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text(AgencyData.agencyName, 7, 10);
      doc.setFontSize(12);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text(AgencyData.city + ", " + AgencyData.country, 7, 17);
      doc.setFontSize(12);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Ph# " + AgencyData.telephoneNumber, 7, 25);
      doc.setFontSize(12);
      doc.setTextColor('#111');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Email: " + AgencyData.emailAddress, 7, 31);
      doc.setDrawColor(255, 170, 0);
      doc.setFillColor(255, 170, 0);
      doc.rect(5, 35, 200, 7, 'F');
      doc.setFontSize(13);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Itinerary Details", 90, 40);
      doc.setFontSize(13);
      doc.setTextColor('#ffaa00');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Flight Details (Onward) : ", 5, 56);
      doc.setDrawColor(255, 170, 0);
      doc.setFillColor(255, 170, 0);
      doc.rect(5, 60, 200, 7, 'F');
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Airline", 10, 64);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Departure", 45, 64);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Arrival", 90, 64);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Duration", 130, 64);
      doc.setFontSize(9);
      doc.setTextColor('#fff');
      doc.setFont('Poppins-Regular-normal');
      doc.text("Baggage", 170, 64);
      if (displayedFlights.airSegmentsNew.length <= 4) {
        //main
        a1 = 13;
        a2 = 67;
        b1 = 45;
        b2 = 74;
        c1 = 90;
        c2 = 74;
        d1 = 130;
        d2 = 74;
        e1 = 170;
        e2 = 74;
        f1 = 10;
        f2 = 80;
        g1 = 45;
        g2 = 80;
        h1 = 90;
        h2 = 80;
        i1 = 10;
        i2 = 85;
        j1 = 45;
        j2 = 85;
        jt1 = 45;
        jt2 = 90;
        k1 = 90;
        k2 = 85;
        kt1 = 90;
        kt2 = 90;
        l1 = 10;
        l2 = 92;
        m1 = 10;
        m2 = 98;
        n1 = 7;
        n2 = 104;
        o1 = 17;
        o2 = 104;
        p1 = 23;
        p2 = 104;

        for (let d = 0; d < displayedFlights.airSegmentsNew.length; d++) {
          let dd = '../../assets/img/' + displayedFlights.airSegmentsNew[0].flightLogo;
          let imgtype = displayedFlights.airSegmentsNew[d].flightLogo.slice(-3);
          try {
            if (imgtype == "svg") {
              const canvass = document.createElement('canvas');
              canvass.width = 900;
              canvass.height = 800;
              const ctx = canvass.getContext('2d');
              const v = await Canvg.from(ctx, dd);
              await v.render();
              var immige = canvass.toDataURL("image/png");
              console.log(immige);
              doc.addImage(immige, 'png', a1, a2, 12, 12);

            } else {
              doc.addImage(dd, 'png', a1, a2, 12, 12);

            }
          } catch (error) {
            console.error("Error loading SVG:", error);
            continue;
          }
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].cabinClass, f1, f2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].carrier + '' + displayedFlights.airSegmentsNew[d].flightNumber, i1, i2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].flightLegalName, l1, l2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].origin.code, b1, b2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].departureDate, g1, g2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].departureTime, j1, j2);
          if (displayedFlights.airSegmentsNew[d].origin.terminal != undefined && displayedFlights.airSegmentsNew[d].origin.terminal != null && displayedFlights.airSegmentsNew[d].origin.terminal != "") {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + displayedFlights.airSegmentsNew[d].origin.terminal, jt1, jt2);
          }
          else {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + "", jt1, jt2);
          }

          //arrival
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].destination.code, c1, c2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].arrivalDate, h1, h2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].arrivalTime, k1, k2);
          if (displayedFlights.airSegmentsNew[d].destination.terminal != "" && displayedFlights.airSegmentsNew[d].destination.terminal != null && displayedFlights.airSegmentsNew[d].destination.terminal != undefined) {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + displayedFlights.airSegmentsNew[d].destination.terminal, kt1, kt2);
          }
          else {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + "", kt1, kt2);
          }
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].flightTime ? displayedFlights.airSegmentsNew[d].flightTime : "--", d1, d2);
          //baggage
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          if (displayedFlights.frontBaggageAllowance != null) {
            doc.text(displayedFlights.frontBaggageAllowance[0].checkinBaggage ? displayedFlights.frontBaggageAllowance[0].checkinBaggage : "--", e1, e2);
          } else {
            doc.text("--", e1, e2);
          }
          //horizontal  line1
          doc.setLineWidth(0.4);
          doc.line(5, m2 + 2, 205, m2 + 2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].equipment ? displayedFlights.airSegmentsNew[d].equipment : "--", n1, n2);
          //vertical line2
          doc.setLineWidth(0.4);
          doc.line(o1 - 2, n2 - 2.5, o1 - 2, n2 + 2.5)
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].cabinClass.slice(0, 1), o1, o2);
          //vertical line3
          doc.setLineWidth(0.4);
          doc.line(p1 - 2, o2 - 2.5, p1 - 2, o2 + 2.5)
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.multiFlights[0].nonRefundable ? "Non Refundable" : "Refundable", p1, p2);
          doc.setLineWidth(0.4);
          doc.line(5, n2 + 2.5, 205, n2 + 2.5);
          a2 = a2 + 44;
          b2 = b2 + 44;
          c2 = c2 + 44;
          d2 = d2 + 44;
          e2 = e2 + 44;
          f2 = f2 + 44;
          g2 = g2 + 44;
          h2 = h2 + 44;
          i2 = i2 + 44;
          j2 = j2 + 44;
          jt2 = jt2 + 44;
          k2 = k2 + 44;
          kt2 = kt2 + 44;
          l2 = l2 + 44;
          m2 = m2 + 44;
          n2 = n2 + 44;
          o2 = o2 + 44;
          p2 = p2 + 44;
        }
        a2 = a2 - 44;
        b2 = b2 - 44;
        c2 = c2 - 44;
        d2 = d2 - 44;
        e2 = e2 - 44;
        f2 = f2 - 44;
        g2 = g2 - 44;
        h2 = h2 - 44;
        i2 = i2 - 44;
        j2 = j2 - 44;
        k2 = k2 - 44;
        l2 = l2 - 44;
        m2 = m2 - 44;
        n2 = n2 - 44;
        o2 = o2 - 44;
        p2 = p2 - 44;
        let fSpace = p2 + 11;
        let baseIs = fSpace + 9;
        doc.setFontSize(14);
        doc.setTextColor('#ffaa00');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Fare Summary", 5, fSpace);
        var bodyData = [];
        displayedFlights.passengerFares.forEach(items => {
          // Apply condition or any other logic
          let pxtype = "";
          if (items.passengerType == "1") {
            pxtype = "Adult";
          }
          else if (items.passengerType == "2") {
            pxtype = "Child";
          }
          else if (items.passengerType == "3") {
            pxtype = "Infant";
          }
          bodyData.push([pxtype + " (" + items.count + ")", items.agencyBaseFareAmount, items.agencyServiceFee, items.agencyDiscount, items.agencyTaxAmount, items.agencyTotalPrice])
        });
        autoTable(doc, {
          head: [['Passenger Type', 'Base Fare', 'Service Fee', 'Discount', 'Taxes', 'Total Amount']],
          headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
          body: bodyData,
          columnStyles: {
            0: { fontSize: 9, valign: 'middle', textColor: [255, 170, 0], fontStyle: 'bold', halign: 'center' },
            1: { fontSize: 9, valign: 'middle', halign: 'center' },
            2: { fontSize: 9, valign: 'middle', halign: 'center' },
            3: { fontSize: 9, valign: 'middle', halign: 'center' },
            4: { fontSize: 9, valign: 'middle', halign: 'center' },
            5: { fontSize: 9, valign: 'middle', halign: 'center' },
          },
          startY: fSpace + 9,
          theme: 'plain',
        })
        let finalYss = (doc as any).lastAutoTable.finalY;
        let summary = finalYss + 9;
        let r = summary;
        let s = summary;
        let t = summary;
        let u = summary;
        x = 8;
        x1 = 40;
        x2 = 130;
        x3 = 190;
        //dotted lines
        doc.setDrawColor(147, 149, 150);
        doc.setLineDashPattern([1, 1, 1, 1, 1], 5);
        doc.line(5, u + 2, 205, u + 2);
        r = r + 6;
        s = s + 6;
        t = t + 6;
        u = u + 6;
        doc.setFontSize(14);
        doc.setTextColor('#8e9394');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Total Gross Fare:", 110, u + 6);
        doc.setFontSize(13);
        doc.setTextColor('#8e9394');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.multiFlights[0].agencyTotalPrice, 160, u + 6);
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(1, 1, 1, 295)
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(209, 1, 209, 295);
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(1, 1, 209, 1)
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(1, 295, 209, 295)
      }
      else if (displayedFlights.airSegmentsNew.length >= 5) {
        a1 = 13;
        a2 = 67;
        b1 = 45;
        b2 = 74;
        c1 = 90;
        c2 = 74;
        d1 = 130;
        d2 = 74;
        e1 = 170;
        e2 = 74;
        f1 = 10;
        f2 = 80;
        g1 = 45;
        g2 = 80;
        h1 = 90;
        h2 = 80;
        i1 = 10;
        i2 = 85;
        j1 = 45;
        j2 = 85;
        jt1 = 45;
        jt2 = 90;
        k1 = 90;
        k2 = 85;
        kt1 = 90;
        kt2 = 90;
        l1 = 10;
        l2 = 92;
        m1 = 10;
        m2 = 98;
        n1 = 7;
        n2 = 104;
        o1 = 17;
        o2 = 104;
        p1 = 23;
        p2 = 104;
        for (let d = 0; d < 5; d++) {
          let dd = '../../assets/img/' + displayedFlights.airSegmentsNew[0].flightLogo;
          let imgtype = displayedFlights.airSegmentsNew[d].flightLogo.slice(-3);
          try {
            if (imgtype == "svg") {
              const canvass = document.createElement('canvas');
              canvass.width = 900;
              canvass.height = 800;
              const ctx = canvass.getContext('2d');
              const v = await Canvg.from(ctx, dd);
              await v.render();
              var immige = canvass.toDataURL("image/png");
              console.log(immige);
              doc.addImage(immige, 'png', a1, a2, 12, 12);

            } else {
              doc.addImage(dd, 'png', a1, a2, 12, 12);

            }
          } catch (error) {
            console.error("Error loading SVG:", error);
            continue;
          }
          //airline
          doc.addImage(immige, 'png', a1, a2, 12, 12);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].cabinClass, f1, f2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].carrier + '' + displayedFlights.airSegmentsNew[d].flightNumber, i1, i2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].flightLegalName, l1, l2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].origin.code, b1, b2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].departureTime, g1, g2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].departureDate, j1, j2);
          if (displayedFlights.airSegmentsNew[d].origin.terminal != undefined && displayedFlights.airSegmentsNew[d].origin.terminal != null && displayedFlights.airSegmentsNew[d].origin.terminal != "") {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + displayedFlights.airSegmentsNew[d].origin.terminal, jt1, jt2);
          }
          else {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + "", jt1, jt2);
          }
          //arrival
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].destination.code, c1, c2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].arrivalTime, h1, h2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].arrivalDate, k1, k2);
          if (displayedFlights.airSegmentsNew[d].destination.terminal != undefined && displayedFlights.airSegmentsNew[d].destination.terminal != "" && displayedFlights.airSegmentsNew[d].destination.terminal != null) {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + displayedFlights.airSegmentsNew[d].destination.terminal, kt1, kt2);
          }
          else {
            doc.setFontSize(11);
            doc.setTextColor('#111');
            doc.setFont('Poppins-Regular-normal');
            doc.text("Terminal:" + "", kt1, kt2);
          }
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].flightTime ? displayedFlights.airSegmentsNew[d].flightTime : "--", d1, d2);
          //baggage
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          if (displayedFlights.frontBaggageAllowance != null) {
            doc.text(displayedFlights.frontBaggageAllowance[0].checkinBaggage ? displayedFlights.frontBaggageAllowance[0].checkinBaggage : "--", e1, e2);
          } else {
            doc.text("--", e1, e2);
          }
          //horizontal  line1
          doc.setLineWidth(0.4);
          doc.line(5, m2 + 2, 205, m2 + 2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].equipment ? displayedFlights.airSegmentsNew[d].equipment : "--", n1, n2);
          //vertical line2
          doc.setLineWidth(0.4);
          doc.line(o1 - 2, n2 - 2.5, o1 - 2, n2 + 2.5)
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].cabinClass.slice(0, 1), o1, o2);
          //vertical line3
          doc.setLineWidth(0.4);
          doc.line(p1 - 2, o2 - 2.5, p1 - 2, o2 + 2.5)
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.multiFlights[0].nonRefundable ? "Non Refundable" : "Refundable", p1, p2);
          doc.setLineWidth(0.4);
          doc.line(5, n2 + 2.5, 205, n2 + 2.5);
          a2 = a2 + 44;
          b2 = b2 + 44;
          c2 = c2 + 44;
          d2 = d2 + 44;
          e2 = e2 + 44;
          f2 = f2 + 44;
          g2 = g2 + 44;
          h2 = h2 + 44;
          i2 = i2 + 44;
          j2 = j2 + 44;
          jt2 = jt2 + 44;
          k2 = k2 + 44;
          kt2 = kt2 + 44;
          l2 = l2 + 44;
          m2 = m2 + 44;
          n2 = n2 + 44;
          o2 = o2 + 44;
          p2 = p2 + 44;
        }
        doc.addPage();
        for (let d = 5; d < displayedFlights.airSegmentsNew.length; d++) {
          p2a1 = 13;
          p2a2 = 12;
          p2b1 = 45;
          p2b2 = 19;
          p2c1 = 90;
          p2c2 = 19;
          p2d1 = 130;
          p2d2 = 19;
          p2e1 = 170;
          p2e2 = 19;
          p2f1 = 10;
          p2f2 = 25;
          p2g1 = 45;
          p2g2 = 25;
          p2h1 = 90;
          p2h2 = 25;
          p2i1 = 10;
          p2i2 = 30;
          p2j1 = 45;
          p2j2 = 30;
          p2k1 = 90;
          p2k2 = 30;
          p2l1 = 10;
          p2l2 = 37;
          p2m1 = 10;
          p2m2 = 43;
          p2n1 = 7;
          p2n2 = 49;
          p2o1 = 17;
          p2o2 = 49;
          p2p1 = 23;
          p2p2 = 49;

          let dd = '../../assets/img/' + displayedFlights.airSegmentsNew[d].flightLogo;
          let imgtype = displayedFlights.airSegmentsNew[d].flightLogo.slice(-3);
          try {
            if (imgtype == "svg") {
              const canvass = document.createElement('canvas');
              canvass.width = 900;
              canvass.height = 800;
              const ctx = canvass.getContext('2d');
              const v = await Canvg.from(ctx, dd);
              await v.render();
              var immige = canvass.toDataURL("image/png");
              console.log(immige);
              doc.addImage(immige, 'png', a1, a2, 12, 12);

            } else {
              doc.addImage(dd, 'png', a1, a2, 12, 12);

            }
          } catch (error) {
            console.error("Error loading SVG:", error);
            continue;
          }
          //airline
          doc.addImage(immige, 'png', p2a1, p2a2, 12, 12);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].cabinClass, p2f1, p2f2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].carrier + '' + displayedFlights.airSegmentsNew[d].flightNumber, p2i1, p2i2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].flightLegalName, p2l1, p2l2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].origin.code, p2b1, p2b2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].departureDate, p2g1, p2g2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].departureTime, p2j1, p2j2);
          //arrival
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].destination.code, p2c1, p2c2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].arrivalDate, p2h1, p2h2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].arrivalTime, p2k1, p2k2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].flightTime ? displayedFlights.airSegmentsNew[d].flightTime : "--", p2d1, p2d2);
          //baggage
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          if (displayedFlights.frontBaggageAllowance != null) {
            doc.text(displayedFlights.frontBaggageAllowance[0].checkinBaggage ? displayedFlights.frontBaggageAllowance[0].checkinBaggage : "--", p2e1, p2e2);
          } else {
            doc.text("--", p2e1, p2e2);
          }
          //horizontal  line1
          doc.setLineWidth(0.4);
          doc.line(5, p2m2 + 2, 205, p2m2 + 2);
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].equipment ? displayedFlights.airSegmentsNew[d].equipment : "--", p2n1, p2n2);
          //vertical line2
          doc.setLineWidth(0.4);
          doc.line(p2o1 - 2, p2n2 - 2.5, p2o1 - 2, p2n2 + 2.5)
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.airSegmentsNew[d].cabinClass.slice(0, 1), p2o1, p2o2);
          //vertical line3
          doc.setLineWidth(0.4);
          doc.line(p2p1 - 2, p2o2 - 2.5, p2p1 - 2, p2o2 + 2.5)
          doc.setFontSize(11);
          doc.setTextColor('#111');
          doc.setFont('Poppins-Regular-normal');
          doc.text(displayedFlights.multiFlights[0].nonRefundable ? "Non Refundable" : "Refundable", p2p1, p2p2);
          doc.setLineWidth(0.4);
          doc.line(5, p2n2 + 2.5, 205, p2n2 + 2.5);
          p2a2 = p2a2 + 44;
          p2b2 = p2b2 + 44;
          p2c2 = p2c2 + 44;
          p2d2 = p2d2 + 44;
          p2e2 = p2e2 + 44;
          p2f2 = p2f2 + 44;
          p2g2 = p2g2 + 44;
          p2h2 = p2h2 + 44;
          p2i2 = p2i2 + 44;
          p2j2 = p2j2 + 44;
          p2k2 = p2k2 + 44;
          p2l2 = p2l2 + 44;
          p2m2 = p2m2 + 44;
          p2n2 = p2n2 + 44;
          p2o2 = p2o2 + 44;
          p2p2 = p2p2 + 44;
        }
        if (displayedFlights.airSegmentsNew.length == 5) {
          p2a1 = 13;
          p2a2 = 12;
          p2b1 = 45;
          p2b2 = 19;
          p2c1 = 90;
          p2c2 = 19;
          p2d1 = 130;
          p2d2 = 19;
          p2e1 = 170;
          p2e2 = 19;
          p2f1 = 10;
          p2f2 = 25;
          p2g1 = 45;
          p2g2 = 25;
          p2h1 = 90;
          p2h2 = 25;
          p2i1 = 10;
          p2i2 = 30;
          p2j1 = 45;
          p2j2 = 30;
          p2k1 = 90;
          p2k2 = 30;
          p2l1 = 10;
          p2l2 = 37;
          p2m1 = 10;
          p2m2 = 43;
          p2n1 = 7;
          p2n2 = 49;
          p2o1 = 17;
          p2o2 = 49;
          p2p1 = 23;
          p2p2 = 49;
        }
        p2a2 = p2a2 - 44;
        p2b2 = p2b2 - 44;
        p2c2 = p2c2 - 44;
        p2d2 = p2d2 - 44;
        p2e2 = p2e2 - 44;
        p2f2 = p2f2 - 44;
        p2g2 = p2g2 - 44;
        p2h2 = p2h2 - 44;
        p2i2 = p2i2 - 44;
        p2j2 = p2j2 - 44;
        p2k2 = p2k2 - 44;
        p2l2 = p2l2 - 44;
        p2m2 = p2m2 - 44;
        p2n2 = p2n2 - 44;
        p2o2 = p2o2 - 44;
        p2p2 = p2p2 - 44;
        let fSpace = p2p2 + 11;
        let baseIs = fSpace + 9;
        doc.setFontSize(16);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Fare Summary", 5, fSpace);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.rect(5, fSpace + 2, 200, 9, 'F');
        doc.setFontSize(12);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Pax Type", 8, baseIs);
        doc.setFontSize(12);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Base Fare", 80, baseIs);
        doc.setFontSize(12);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Tax & Charges", 130, baseIs);
        doc.setFontSize(12);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Total", 175, baseIs);
        let summary = baseIs + 9;
        let r = summary;
        let s = summary;
        let t = summary;
        let u = summary;
        x = 8;
        x1 = 80;
        x2 = 130;
        x3 = 190;
        doc.setFontSize(11);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text("All travellers", x, s);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.multiFlights[0].agencyBaseFareAmount, x1, s);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.multiFlights[0].agencyTaxAmount, x2, t);
        doc.setFontSize(10);
        doc.setTextColor('#111');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.multiFlights[0].agencyTotalPrice, x3 - 15, u);
        //dotted lines
        doc.setDrawColor(147, 149, 150);
        doc.setLineDashPattern([1, 1, 1, 1, 1], 5);
        doc.line(5, u + 2, 205, u + 2);
        r = r + 6;
        s = s + 6;
        t = t + 6;
        u = u + 6;
        doc.setFontSize(12);
        doc.setTextColor('#8e9394');
        doc.setFont('Poppins-Regular-normal');
        doc.text("Total Gross Fare:", 125, u + 6);
        doc.setFontSize(12);
        doc.setTextColor('#8e9394');
        doc.setFont('Poppins-Regular-normal');
        doc.text(displayedFlights.multiFlights[0].agencyTotalPrice, 165, u + 6);
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(1, 1, 1, 295)
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(209, 1, 209, 295);
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(1, 1, 209, 1)
        doc.setLineWidth(0.6);
        doc.setDrawColor(107, 107, 107);
        doc.setFillColor(213, 213, 213);
        doc.setLineDashPattern([0, 0], 0);
        doc.line(1, 295, 209, 295)
      }
      let pdfname = displayedFlights.multiFlights[0].departure.city + "-->" + displayedFlights.multiFlights[displayedFlights.multiFlights.length - 1].arrival.city + "(MultiCity).pdf";
      doc.save(pdfname);
    } catch (e) {
      console.log(e);
    }
  }
}
